import zhtLocale from 'element-ui/lib/locale/lang/zh-TW'

export default {
  LanguageLib: {
    _THE_SYSTEM_WILL_AUTOMATICALLY_COMPRESS_THE_PICTURE_INTO_2000_STAR_2000_AND_UPLOAD: '系统会自动将图片压缩成2000*2000后上传',
    ABOUT_PAGE_MAP: '关于页面图',
    ACCEPT_PICTURE_CONFIGURATION: '验收图片配置',
    ACCEPTANCE_REPORT: '验收报告',
    ACCEPTANCE_SCORE_IS_REQUIRED: '验收打分是否必填',
    ACCESSORIES_NAME: '配件名称',
    ACCESSORY_NAME: '附件名称',
    ACCOUNT: '账号',
    ExcelTemplate_common_000009: '账号',
    ACCOUNT_NUMBER: '账期序号',
    ACTIVATION: '激活',
    ACTUAL_SCORE: '实际分值',
    ADD_A_STORE_CAMERA: '添加店铺摄像头',
    ADD_ASSET_TYPE: '添加资产类型',
    ADD_ASSET_TYPE_FAILED: '添加资产类型失败',
    ADD_BRAND: '添加品牌',
    ADD_BRAND_TYPE: '添加品牌类型',
    ADD_CAMERA_INFORMATION: '添加摄像头信息',
    ADD_CATEGORY: '添加类别',
    ADD_CATEGORY_NAME_CANNOT_BE_KEYWORDS_FOR_SHOP_PROVINCE_CITY_COUNTRY_ETC: '添加类别名称不可为店铺，省，市，国家等关键字',
    ADD_CONTACT: '添加联系人',
    ADD_COURSE: '添加课程',
    ADD_COURSEWARE: '添加课件',
    ADD_DATA_ON_THE_REPORT_SHEET: '添加数据上报表单：',
    ADD_DATE: '添加日期',
    ADD_DEALER: '添加经销商',
    ADD_DEALER_TYPE: '添加经销商类型',
    ADD_DEFECTIVE_PARTS: '添加次品配件',
    ADD_DEFECTIVE_PRODUCT_CLASSIFICATION: '添加次品问题分类',
    ADD_DISTRIBUTOR_CORPORATE: '添加经销商/法人',
    ADD_EMPLOYEE: '添加员工',
    ADD_FAILED: '添加失败',
    ADD_FAILED_BUSINESS_START_TIME_CANNOT_BE_LESS_THAN_END_TIME: '添加失败,营业起始时间不能小于结束时间',
    ADD_FAILED_DO_NOT_ADD_EXISTING_NONCUSTOM_ORGANIZATION: '添加失败,不可添加已有的非自定义组织',
    ADD_FAILED_NO_CORRECT_ANSWER_EXISTS_IN_OPTIONS: '添加失败,选项中不存在正确答案',
    ADD_FAILED_START_TIME_CANNOT_BE_GREATER_THAN_END_TIME: '添加失败,开始时间不能大于结束时间',
    ADD_FAILED_START_TIME_CANNOT_BE_LESS_THAN_TODAY: '添加失败,开始时间不能小于今天',
    ADD_FAILED_THE_ACCOUNT_IS_NOT_A_SUPPLIER_USER: '添加失败,该账号不是供应商用户',
    ADD_FAILED_THE_BRAND_ALREADY_EXISTS: '添加失败,该品牌已存在',
    ADD_FAILED_THE_PHONE_NUMBER_USER_ALREADY_EXISTS: '添加失败,该手机号用户已存在',
    ADD_FAILED_THE_SAME_ORGANIZATION_OR_STORE_NAME_ALREADY_EXISTS: '添加失败,已存在相同组织或店铺名称',
    ADD_FAILED_THE_TEMPLATE_NAME_ALREADY_EXISTS: '添加失败,该模板名称已经存在',
    ADD_FAILED_WITH_AT_LEAST_TWO_OPTIONS_FOR_A_TOPIC: '添加失败,一个题目至少有两个选项',
    ADD_FAILED1: '添加失败，',
    ADD_FAILED2: '添加失败！',
    ADD_FAILED3: '添加失败:',
    ADD_FILE_TYPE: '添加文件类型',
    ADD_FOLDER: '添加文件夹',
    ADD_GENERAL_DATA: '添加通用数据',
    ADD_GREETING_RETURN_VISIT_TYPE: '添加问候回访类型',
    ADD_HISTORICAL_EXCHANGE_RATES: '添加历史汇率',
    ADD_ITEM_CATEGORY_SUCCESSFULLY: '添加道具类别成功',
    ADD_JOB: '添加职位',
    ADD_MAINTENANCE_PROBLEM_CLASSIFICATION: '添加维修问题分类',
    ADD_MAINTENANCE_QUESTION: '添加维修问题',
    ADD_NEW_LABEL: '添加新标签',
    ADD_ORGANIZATION: '添加组织',
    ADD_ORGANIZATION_NODE_SUCCESSFULLY: '添加组织节点成功',
    ADD_ORGANIZATION_TYPE: '添加组织类型',
    ADD_PASSENGER_FLOW: '添加客流',
    ADD_PASSENGER_FLOW_ADJUSTMENTS: '添加客流调整',
    ADD_PEOPLE: '添加人员',
    ADD_PERSON_FAILED: '添加人员失败',
    ADD_PERSONNEL_ASSESSMENT_TEMPLATE_QUESTIONS: '添加人员考核模板问题',
    ADD_PURCHASE_RECORD: '添加购买记录',
    ADD_PURCHASE_RECORD_FAILED: '添加购买记录失败',
    ADD_QUESTION: '添加问题',
    ADD_QUESTION_BANK_QUESTIONS: '添加题库问题',
    ADD_REGION: '添加地区',
    ADD_RELATIONSHIP: '添加关系',
    ADD_RETAIL_TOUR_TEMPLATE: '添加零售巡店模板问题分类',
    ADD_ROLE: '添加角色',
    ADD_SALES: '添加销量',
    ADD_SALES_DATA: '添加销售数据',
    ADD_SHOP: '添加店铺',
    ADD_SHOP_EQUIPMENT: '添加店铺设备',
    ADD_SHOP_TYPE: '添加店铺类型',
    ADD_SUPPLIER: '添加供应商',
    ADD_TAG: '添加标签',
    ADD_TASK_TYPE: '添加任务类型',
    ADD_TEMPLATE: '添加模板',
    ADD_TEST_PAPER: '添加试卷',
    ADD_TEST_QUESTIONS: '添加试题',
    ADD_TIME: '添加时间',
    ADD_TO: '添加',
    ADD_TO_TEST_PAPER: '添加到试卷',
    ADD_TRANSFER_LABEL: '添加交接本标签',
    ADD_USER_REFERENCE: '添加用户参照',
    ADD_VENDOR_TYPE: '添加供应商类型',
    ADDED_SUCCESSFULLY: '添加成功',
    ADDED_SUCCESSFULLY1: '添加成功！',
    ADDING_A_STORE_CAMERA_FAILED: '添加店铺摄像头失败',
    ADDING_A_STORE_FAILED: '添加店铺失败',
    ADDING_ASSETS: '添加资产',
    ADDING_COMPETITION_CATEGORY_SUCCESSFUL: '添加竞品类别成功',
    ADDING_COMPETITOR_CATEGORY_FAILED: '添加竞品类别失败',
    ADDING_CUSTOM_FIELDS: '添加自定义字段',
    ADDING_CUSTOM_FIELDS_FAILED: '添加自定义字段失败',
    ADDING_DEFECTIVE_PARTS_FAILED: '添加次品配件失败',
    ADDING_DEFECTIVE_PRODUCT_CLASSIFICATION_FAILED: '添加次品问题分类失败',
    ADDING_FAILED_THE_NUMBER_OF_ORGANIZATIONS_IN_THE_ORGANIZATION_HAS_REACHED_THE_UPPER_LIMIT: '添加失败，该组织下组织数量已达上限',
    ADDING_GENERIC_DATA_FAILED: '添加通用数据失败',
    ADDING_MAINTENANCE_ISSUES_FAILED: '添加维修问题失败',
    ADDING_ORGANIZATION_NODE_FAILED: '添加组织节点失败',
    ADDING_PASSENGER_FLOW_FAILED: '添加客流失败,',
    ADDING_RETAIL_TOUR_TEMPLATES: '添加零售巡店模板问题',
    ADDING_STORE_EQUIPMENT_FAILED: '添加店铺设备失败',
    ADDING_USER_REFERENCE_FAILED: '添加用户参照失败',
    ADJUSTMENT_COEFFICIENT: '调整系数',
    ADJUSTMENT_INFORMATION: '调整信息',
    ADMINISTRATOR: '管理员',
    AFFILIATES: '所属公司',
    AFTER_DELETING_THE_COURSE_ALL_THE_COURSEWARE_IN_THE_COURSE_WILL_BE_DELETED_TOGETHER_PLEASE_CONFIRM_WHETHER_TO_DELETE: '删除课程后，课程内的全部课件将一起删除，请确认是否删除？',
    AFTER_THE_PHONE_NUMBER: '手机号码后',
    AGE: '年龄',
    AGREEMENT_CONTENT_CANNOT_BE_EMPTY: '协议内容不可为空',
    AGREEMENT_DOWNLOAD: '协议下载',
    AGREEMENT_MUST_BE_SIGNED_AT_LOGIN: '登录时必须签署协议',
    ALL: '全部',
    ALL_TAGS: '所有标签',
    ALL_UNSAVED_CHANGES_HAVE_BEEN_UNDONE: '所有未保存的更改已被撤销',
    ALLOW_EXPORT_OF_CONTACTS: '允许导出通讯录',
    ALLOW_MULTIPLE_PEOPLE: '允许多人',
    ALLOWS_MODIFICATION_OF_SCORES_WHEN_ENTRIES_ARE_NOT_UP_TO_STANDARD: '条目不达标时,允许修改得分',
    ALREADY_COPIED_TO_THE_CLIPBOARD: '已经复制到剪切板！',
    ALREADY_HAVE_THE_SAME_AREA_CODE: '已有相同地区编号;',
    ALREADY_HAVE_THE_SAME_ORGANIZATION_OR_SHOP_NAME: '已有相同组织或店铺名称;',
    worker_common_000009: '已有相同组织或店铺名称;',
    ALREADY_HAVE_THIS_OPTION: '已经有该选项',
    AN_AREA_WITH_THE_SAME_NAME_ALREADY_EXISTS: '已有相同名称地区;',
    AN_ERROR_OCCURRED: '出现错误：',
    AN_ORGANIZATION_WITH_THE_SAME_NAME_ALREADY_EXISTS: '已有相同名称组织;',
    AN_UNKNOWN_ERROR_OCCURRED: '出现未知错误',
    ANNEX: '附件',
    ANNIVERSARY: '纪念日',
    ANNOUNCER: '发布者',
    ANSWER: '答案',
    ANSWER_CASE: '答　　案',
    ANSWER_NUMBER: '接听号码',
    APPLY_FOR_REPAIRS_AND_PROPS: '报修、道具申请提交图片配置',
    ARE_YOU_SATISFIED: '是否满意',
    ARE_YOU_SURE_TO_DISABLE: '是否确认停用？',
    ARE_YOU_SURE_TO_DOWNLOAD_THE_REPAIR_CODE: '确定下载报修码？',
    ARE_YOU_SURE_TO_FREEZE: '是否确认冻结？',
    ARE_YOU_SURE_TO_GENERATE_A_REPAIR_CODE: '确定生成报修码？',
    ARE_YOU_SURE_TO_UNFREEZE: '是否确认解除冻结？',
    ARE_YOU_SURE_YOU_WANT_TO_ADD_FROM_THE_QUESTION_BANK: '是否确认从题库添加？',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_IT: '是否确认删除？',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_IT1: '是否确认删除?',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_SELECTED_COURSEWARE: '确认删除选中的课件?',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_SELECTED_EXAM: '您确认要删除选中的考题吗？',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_SELECTED_TEST_PAPER: '您确认要删除选中的试卷吗？',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_QUESTION: '您确认删除此题吗？',
    ARE_YOU_SURE_YOU_WANT_TO_ENABLE_IT: '是否确认启用？',
    ARE_YOU_SURE_YOU_WANT_TO_RESET_THE_USER_PASSWORD: '是否确认重置用户密码？',
    ARE_YOU_SURE_YOU_WANT_TO_RESET_THE_USER_PASSWORD1: '是否确认重置该用户密码？',
    ARE_YOU_SURE_YOU_WANT_TO_SEND_THE_MESSAGE: '是否确认发送消息？',
    AREA: '所在地区',
    AREA_CODE: '地区编号',
    AREA_INFORMATION: '地区信息',
    AREA_INFORMATION_ADDED: '地区信息添加',
    AREA_INFORMATION_UPDATE: '地区信息更新',
    AREA_NAME: '地区名称',
    AREA1: '地区',
    ARTICLE_NUMBER: '货品编号',
    ASSET_CATALOG: '资产目录',
    ASSET_CATALOG_SETTINGS: '资产目录设定',
    ASSET_CLASS_INFORMATION: '资产类别信息',
    ASSET_CONTENT_SETTINGS: '资产内容设定',
    ASSET_INFORMATION: '资产信息',
    ASSET_NAME: '资产名称',
    ASSET_NUMBER: '资产编号',
    ASSIGN_TASKS_IMMEDIATELY_AFTER_SUBMITTING_REPORT: '提交报告后立即分配任务',
    ASSOCIATED_USER: '关联用户',
    ATTACHMENT: '附　　件',
    ATTACHMENT_ID_DOES_NOT_EXIST: '附件id不存在;',
    ATTACHMENT_TYPE: '附件类型',
    AUTHOR: '作者',
    AUTHORITY: '权限',
    AUTHORIZATION_MANAGEMENT: '授权管理',
    AUTOAPPROVED_CATEGORIES_MUST_SELECT_THE_DEFAULT_VENDOR: '自动审批的类别必须选择默认供应商',
    AUTOMATIC_APPROVAL: '自动审批',
    AVERAGE_NUMBER_OF_TRANSACTIONS: '平均交易数量',
    AVERAGE_PASSENGER_FLOW: '客流平均',
    AVERAGE_SALES: '平均销量',
    AVERAGE_TRANSACTION_AMOUNT: '平均交易金额',
    BACKUP_PHONE: '备用电话',
    BAIDU_MAP_API_CUSTOM_MAPS_TO_HELP_USERS_GENERATE_BAIDU_MAPS_UNDER_VISUAL_OPERATION: '百度地图API自定义地图，帮助用户在可视化操作下生成百度地图',
    BAIDU_MAP_BAIDU_MAP_API_BAIDU_MAP_CUSTOMIZATION_TOOL_BAIDU_MAP_WYSIWYG_TOOL: '百度地图,百度地图API，百度地图自定义工具，百度地图所见即所得工具',
    BASE_FIELD: '基础字段',
    BASIC_CONFIGURATION: '基础配置',
    BASIC_DATA_IMPORT: '基础数据导入',
    BASIC_INFORMATION: '基本信息',
    BASIC_SETTINGS: '基本设置',
    BATCH_DOWNLOAD: '批量下载',
    BATCH_TAG: '批量标签',
    BEGINNING_NUMBER: '期初数',
    BEGINNING_TIME: '期初时间',
    BIND_MAILBOX: '绑定邮箱',
    BIND_PHONE_NUMBER: '绑定手机号',
    BINDING_RELATIONSHIP: '绑定关系',
    BIRTH_DAY: '生日',
    BIRTHDAY: '生日',
    ExcelTemplate_common_000018: '生日',
    BIT: '位',
    BRAND: '所属品牌',
    BRAND_ADDITION: '品牌添加',
    BRAND_CATEGORIES_IN_USE_CANNOT_BE_DELETED: '正在使用的品牌分类，不能删除！',
    BRAND_CATEGORIES_IN_USE_CANNOT_BE_DELETED1: '正在使用的品牌分类,不能删除！',
    BRAND_CATEGORY: '品牌类别',
    BRAND_CATEGORY_DOES_NOT_EXIST: '品牌类别不存在',
    BRAND_CATEGORY1: '品牌分类',
    BRAND_CUSTOMERS: '品牌客户',
    BRAND_DATA_IMPORT: '品牌数据导入',
    BRAND_DATA_TEMPLATE: '品牌数据模板',
    BRAND_INFORMATION: '品牌信息',
    BRAND_INTRODUCTION: '品牌介绍',
    BRAND_NAME: '品牌名称',
    BRAND_REMOVAL_FAILED: '删除品牌失败',
    BRAND_SETTINGS: '品牌设定',
    BRAND_TYPE: '品牌类型',
    BRAND_TYPE_DOES_NOT_EXIST: '品牌类型不存在;',
    BRAND_TYPE_INFORMATION: '品牌类型信息',
    BRAND_TYPE_NAME: '品牌类型名称',
    BRAND_TYPE_NUMBER: '品牌类型编号',
    BRAND_UPDATE: '品牌更新',
    BROADCAST: '广播',
    BUILD_FAILED: '生成失败',
    BUILD_FAILED1: '生成失败：',
    BUILD_TIME: '生成时间',
    BULK_ENABLE: '批量启用',
    BUSINESS_HOURS: '营业时间',
    BY: '通过',
    BY_SERIAL_NUMBER: '按序号',
    BY_UPDATE_TIME: '按更新时间',
    CALL_DURATION: '通话时长',
    CAMERA_ADDRESS: '摄像头地址',
    CAMERA_INFORMATION: '摄像头信息',
    CAMERA_INFORMATION_ADDED: '摄像头信息添加',
    CAMERA_INFORMATION_UPDATE: '摄像头信息更新',
    CAMERA_NAME: '摄像头名称',
    CAN_NOT_BE_EMPTY: '不能为空',
    CAN_NOT_BE_EMPTY1: '不能为空;',
    CANCEL: '取消',
    CANNOT_BE_DELETED: '不能删除',
    CANNOT_EDIT_CURRENCY_NAME: '不能编辑货币名称',
    CATEGORIES: '商品分类',
    CATEGORY: '所属类别',
    CATEGORY_CODE: '类别编码',
    CATEGORY_DESCRIPTION: '类别描述',
    CATEGORY_DETAILS: '类别详情',
    CATEGORY_INFORMATION: '类别信息',
    CATEGORY_NAME: '分类名称',
    CATEGORY_NUMBER: '类别编号',
    CATEGORY_NUMBER1: '类别序号',
    CATEGORY_UNIQUE_ID_CANNOT_BE_EMPTY: '分类唯一ID不能为空;',
    CATEGORY1: '类别',
    CC: '抄送人',
    CHANGE_PASSWORD_AT_FIRST_LOGIN: '初次登录修改密码',
    CHANNEL_DESCRIPTION: '通道说明',
    CHANNEL_DESCRIPTION_CANNOT_EXCEED_1000_WORDS: '通道说明不能超过1000字',
    CHANNEL_LIST: '通道列表',
    CHANNEL_NAME: '通道名称',
    CHANNEL_NUMBER: '通道编号',
    CHANNEL_NUMBERS_CANNOT_BE_DUPLICATED: '通道编号不能重复;',
    CHANNEL_TYPE: '通道类型',
    CHARACTER_LENGTH_EXCEEDS: '字符长度超过',
    CHARACTER_LENGTH_EXCEEDS_THE_LIMIT: '字符长度超过限制;',
    CHECK_BRAND: '查询品牌',
    CHECK_IN_TIME: '登记时间',
    CHECK_THE_PROMPT_FILE: ',是否查看提示文件?',
    CHECKED_FIELDS_ARE_SHOWN_UNCHECKED_ARE_HIDDEN_FIELDS: '勾选的为显示字段，未勾选的为隐藏字段',
    CHILDREN_S_SITUATION: '子女情况',
    CHINESE_SIMPLIFIED: '中文简体',
    CHOICE_1: '选择1',
    CHOICE_2: '选择2',
    CHOICE_3: '选择3',
    CHOICE_4: '选择4',
    CHOICE_5: '选择5',
    CHOOSE_A_STORE: '选择店铺',
    CHOOSE_FROM_A_QUESTION_BANK: '从题库选择',
    CLASSIFICATION: '分类',
    CLASSIFICATION_NAME: '类别名称',
    CLASSIFICATION_RENAME: '分类重命名',
    CLEAR: '清空',
    CLIENT: '客户',
    CLIENTS_NAME: '客户名称',
    CODE_REFRESH: '代码刷新',
    CODING: '编码',
    CODING_CANNOT_BE_REPEATED: '编码不能重复;',
    COLLAPSE: '收起',
    PUT_AWAY: '收起',
    COMMENT: '评论',
    COMMENT_BY: '评论者',
    COMMENT_TIME: '评论时间',
    COMMODITY_CATEGORY: '商品大类',
    COMMODITY_ORGANIZATION_RELATIONSHIP: '商品组织关系',
    COMMODITY_SMALL_CLASS: '商品小类',
    COMPANY_ADD: '公司添加',
    COMPANY_ADDRESS: '公司地址',
    COMPANY_CONFIGURATION: '公司配置',
    COMPANY_DEFAULT_LANGUAGE_CANNOT_BE_EMPTY: '公司默认语言不能为空;',
    COMPANY_DESCRIPTION: '公司描述',
    COMPANY_DETAILS: '公司详情',
    COMPANY_EMAIL: '公司邮箱',
    COMPANY_HOMEPAGE_MAP: '公司主页图',
    COMPANY_INFORMATION: '公司信息',
    COMPANY_NAME: '公司名称',
    COMPANY_NUMBER: '公司编号',
    COMPANY_PHONE: '公司电话',
    COMPETING_PICTURE: '竞品图片:',
    COMPETITION_CATEGORY: '竞品分类',
    COMPETITION_CATEGORY_IMPORT: '竞品分类导入',
    COMPETITION_INFORMATION: '竞品信息',
    COMPETITION_INFORMATION_IMPORT: '竞品信息导入',
    COMPETITION_NUMBER: '竞品编号',
    COMPETITIVE_DATA_IMPORT: '竞品数据导入',
    COMPETITIVE_NAME: '竞品名称',
    COMPETITIVE_PRODUCT_CLASSIFICATION_INFORMATION: '竞品分类信息',
    COMPETITIVE_STATUS: '竞品状态',
    COMPLETE_TIME: '完成时间',
    COMPLETED: '已完成',
    COMPLETION_REPORT_CONFIRMATION_TIME: '完工报告确认时间',
    COMPLIANCE_SCORE: '达标得分',
    CONFIGURATION_ENTRY: '配置条目',
    CONFIRM: '确认',
    CONFIRM_SYNCHRONIZATION_EASY_TO_KNOW_USER_DATA: '确认同步易知用户数据？',
    CONTACT_ADDRESS: '联系地址',
    CONTACT_DETAILS: '联系方式',
    ExcelTemplate_common_000021: '联系方式',
    CONTACT_INFORMATION: '联系人信息',
    CONTACT_NAME: '联系人姓名',
    CONTACT_NUMBER: '联系电话',
    CONTACT_NUMBER1: '联系人电话',
    CONTACT_PERSON: '联系人',
    CONTACT_SETTINGS: '联系人设置',
    CONTACT_US: '联系我们',
    CONTENT: '内容',
    CONTENT1: '内容:',
    CONTROL_EDITING: '控件编辑',
    CONVERSION_RATE: '转换率',
    COPIED_TO_CLIPBOARD: '已复制到剪贴板:',
    COPIED_TO_CLIPBOARD1: '已复制到剪贴板',
    COPY: '复制',
    COPY_TO_CLIPBOARD_FAILED: '复制到剪贴板失败:',
    CORRECTION_REPORT: '整改报告',
    COURSE_CREATOR: '课程创建人',
    COURSE_DETAILS: '课程详情',
    COURSE_INFORMATION: '课程信息',
    COURSE_MANAGEMENT: '课程管理',
    COURSE_MODIFICATION_TIME: '课程修改时间',
    COURSE_NO: '课程编号',
    COURSE_NOTES: '课程备注',
    COURSE_NUMBER: '课程序号',
    COURSE_PICTURES: '课程图片',
    COURSE_TITLE: '课程名称',
    COURSE_TYPE: '课程类型',
    COURSEWARE_ADDED_SUCCESSFULLY: '课件添加成功',
    COURSEWARE_ADDITION_FAILED: '课件添加失败',
    COURSEWARE_CODING: '课件编码',
    COURSEWARE_CREATOR: '课件创建人',
    COURSEWARE_DETAILS: '课件详情',
    COURSEWARE_HOME: '课件主页',
    COURSEWARE_INFORMATION: '课件信息',
    COURSEWARE_MODIFICATION_FAILED: '课件修改失败',
    COURSEWARE_MODIFIED_SUCCESSFULLY: '课件修改成功',
    COURSEWARE_NAME: '课件名称',
    COURSEWARE_NOTES: '课件备注',
    COURSEWARE_NUMBER: '课件编号',
    COURSEWARE_PICTURE: '课件图片',
    COURSEWARE_SERIAL_NUMBER: '课件序号',
    COURSEWARE_UPLOAD: '课件上传',
    CREATE_DATA: '创建数据',
    CREATION_DATE: '创建日期',
    CREATION_TIME: '创建时间',
    CREATOR: '创建者',
    CROP: '裁切',
    CURRENCY: '货币',
    CURRENCY_NAME: '货币名称',
    CURRENCY_SETTING: '货币设置',
    CURRENCY_TYPE_DOES_NOT_EXIST: '货币类型不存在;',
    CURRENCY_TYPE_IS_NOT_ACTIVATED: '货币类型未激活;',
    CURRENT_EXCHANGE_RATE_SETTINGS: '当前汇率设置',
    CUSTOM_FIELD: '自定义字段',
    CUSTOM_FIELD_DOES_NOT_EXIST_IN_EXCEL: 'Excel中自定义字段不存在',
    CUSTOM_FIELD_INFORMATION: '自定义字段信息',
    CUSTOMER_DATA_IMPORT: '客户数据导入',
    CUSTOMER_DATA_TEMPLATE: '客户数据模板',
    CUSTOMER_INFORMATION: '客户信息',
    CUSTOMER_LIST: '客户列表',
    CUSTOMER_MANAGEMENT: '客户管理',
    CUSTOMER_NAME: '客户名',
    CUSTOMER_NICKNAME: '客户别称',
    CUSTOMER_S_NAME: '客户姓名',
    DAILY_PRODUCTS: '日产品数',
    DAILY_SALES: '日销售额',
    DAILY_TRAFFIC: '日客流量',
    DATA_CLASSIFICATION: '数据分类',
    DATA_ENCODING: '数据编码',
    DATA_ID: '数据ID',
    DATA_IS_INCORRECT_PLEASE_VERIFY: '数据有误,请校验',
    DATA_NAME: '数据名称',
    DATA_PROCESSING_IS_COMPLETE: '数据处理完毕!',
    DATA_REPORTING: '数据上报',
    m_info_common_000036: '数据上报',
    DATA_REPORTING_MANAGEMENT: '数据上报管理',
    DATA_STEWARD: '数据管理员',
    DATA_TEMPLATE_MANAGEMENT: '数据模板管理',
    DATA_TOP_COLLATION: '数据置顶排序规则',
    DATA_TYPE_CONVERSION_FAILED_IT_SHOULD_BE_DATE_TYPE: '数据类型转换失败，应该为日期型;',
    DATA_TYPE_CONVERSION_FAILED_IT_SHOULD_BE_NUMERIC: '数据类型转换失败，应该为数值型;',
    DATE: '日期',
    DATE_RANGE: '日期范围',
    DAY: '天',
    DEALER__CORPORATE_MANAGEMENT: '经销商/法人管理',
    DEALER_ADDED: '经销商添加',
    DEALER_CORPORATE: '经销商/法人',
    DEALER_CORPORATE_INFORMATION: '经销商/法人信息',
    DEALER_DATA_IMPORT: '经销商数据导入',
    DEALER_LEGAL_NAME: '经销商/法人名称',
    DEALER_TYPE: '经销商类型',
    DEALER_TYPE_INFORMATION: '经销商类型信息',
    DEALER_UPDATE: '经销商更新',
    DECIMAL_PLACES: '保留小数位',
    DECIMALS: '保留小数',
    DECORATION_MAINTENANCE: '装修/维护',
    DECORATION_PERIOD: '可装修时段',
    DEFAULT_LANGUAGE: '默认语言',
    DEFAULT_PASSWORD_FORMAT: '默认密码格式',
    DEFAULT_PRIORITY: '默认优先级',
    DEFAULT_VENDOR: '默认供应商',
    DEFECTIVE_PARTS: '次品部位',
    DEFECTIVE_PARTS1: '次品配件',
    DEFECTIVE_PRODUCT: '次品问题',
    DEFECTIVE_REPAIR: '次品报修',
    m_info_common_000007: '次品报修',
    DELETE: '删除',
    DELETE_A_STAFF_ASSESSMENT_TEMPLATE: '删除人员考核模板',
    DELETE_ASSET: '删除资产',
    DELETE_ASSET_TYPE: '删除资产类型',
    DELETE_CATEGORY: '删除类别',
    DELETE_COMMON_DATA: '删除通用数据',
    DELETE_COURSE: '删除课程',
    DELETE_COURSEWARE: '删除课件',
    DELETE_CUSTOM_FIELDS: '删除自定义字段',
    DELETE_CUSTOMER: '删除客户',
    DELETE_CUSTOMER_FAILED: '删除客户失败',
    DELETE_DOCUMENT: '删除文档',
    DELETE_EXAM_RECORD: '删除考试记录',
    DELETE_FAILED_THERE_ARE_CHILD_NODES_UNDER_THE_DELETE_NODE: '删除失败,删除节点下面有子节点',
    DELETE_FILE_TYPE: '删除文件类型',
    DELETE_GREETING_RETURN_VISIT_TYPE: '删除问候回访类型',
    DELETE_JOB: '删除职位',
    DELETE_JOB_SHOP_TEMPLATE: '删除职店模板',
    DELETE_MAINTENANCE_PROBLEM_CLASSIFICATION: '删除维修问题分类',
    DELETE_ORGANIZATION: '删除组织',
    DELETE_ORGANIZATION_TYPE: '删除组织类型',
    DELETE_PASSENGER_FLOW: '删除客流',
    DELETE_PERSON: '删除人员',
    DELETE_PURCHASE_HISTORY: '删除购买记录',
    DELETE_QUESTION: '删除试卷问题',
    DELETE_QUESTION_BANK: '删除题库',
    DELETE_QUESTION_BANK_QUESTIONS: '删除题库问题',
    DELETE_QUESTION2: '删除题库问题',
    DELETE_QUESTION1: '删除问题',
    DELETE_RECORD: '删除记录',
    DELETE_REGION: '删除地区',
    DELETE_REPORT_FIELD_ON_DATA: '删除数据上报表单字段',
    DELETE_ROLE: '删除角色',
    DELETE_SALES_DATA: '删除销售数据',
    DELETE_STORE: '删除店铺',
    DELETE_STORE_ATTACHMENTS: '删除店铺附件',
    DELETE_STORE_CAMERA: '删除店铺摄像头',
    DELETE_STORE_TYPE: '删除店铺类型',
    DELETE_TASK_TYPE: '删除任务类型',
    DELETE_TEMPLATE: '删除模板',
    DELETE_TEST_PAPER: '删除试卷',
    DELETE_THE_REPORT_ON_THE_DATA: '删除数据上报表单',
    DELETE_THIS_CATEGORY: '删除交接本分类',
    DELETE_THIS_FAILED_POST: '删除交接本失败帖子',
    DELETE_THIS_POST: '删除交接本帖子',
    DELETE_TRAINING_MATERIALS: '删除培训资料',
    DELETE_TRANSFER_BOOK: '删除交接本',
    DELETE_USER_REFERENCE: '删除用户参照',
    DELETE_VISUAL_DISPLAY_ITEM_DETAILS: '删除视觉陈列项目明细',
    DELETE_VISUAL_DISPLAY_ITEMS: '删除视觉陈列项目',
    DELETION_FAILED_BECAUSE_A_ROLE_IN_THIS_ROLE_IS_ALREADY_USED: '删除失败,因为该角色中有职位已被使用',
    DELETION_FAILED_DELETE_TYPE_ALREADY_USED_IN_TYPE: '删除失败,删除类型中已有被使用的类型',
    DELETION_FAILED_ITEM_WITH_CHILD_MEMBERS_IN_OPTION: '删除失败,选项中存在有子成员的项',
    DELETION_FAILED_ITEMS_USED_IN_ASSET_CONFIGURATION_SETTINGS_EXIST_IN_OPTIONS: '删除失败,选项中存在资产配置设定中使用的项',
    DELETION_FAILED_ITEMS_USED_IN_ITEM_INFORMATION_MANAGEMENT_EXIST_IN_OPTIONS: '删除失败,选项中存在道具信息管理中使用的项',
    DELETION_FAILED_SOMEONE_IN_THE_POST: '删除失败,该职位有人就职',
    DELETION_FAILED_SOMEONE_IS_ALREADY_SERVING: '删除失败,有人员已经任职',
    DELETION_FAILED_THE_ASSET_NAME_USED_IN_THE_STORE_EXISTS_IN_THE_SELECTION: '删除失败,选择项中存在店铺中已使用的资产名称',
    DELETION_FAILED_WITH_ITEMS_USED_IN_MAINTENANCE_INFORMATION_MANAGEMENT_IN_OPTIONS: '删除失败,选项中存在维修信息管理中使用的项',
    DELETION_FAILED_YOU_CANNOT_DELETE_THE_ADJUSTMENT_FACTOR_LESS_THAN_OR_EQUAL_TO_TODAY: '删除失败,不能删除小于等于今天的调整系数',
    DELETION_OF_PERSONNEL_ASSESSMENT_TEMPLATE: '删除人员考核模板问题',
    DESCRIPTION: '说明',
    DESCRIPTION1: '描述',
    DETAILS: '详情',
    DETAILS_AND_COMMENTS: '详情与评论',
    DETERMINE: '确定',
    DEVIATION: '偏差',
    DEVICE_CODE: '设备码',
    DEVICE_DESCRIPTION: '设备说明',
    DEVICE_MAC_ADDRESS: '设备MAC地址',
    DEVICE_NAME: '设备名称',
    DIRECTORY: '所属目录',
    DISABLE: '停用',
    DISCOUNT_FACTOR: '折扣系数',
    DISPLAY_BROCHURE: '陈列手册',
    DISPLAY_BROCHURE_CONFIGURATION_TEMPLATE: '陈列手册配置模板',
    DISPLAY_BROCHURE_TEMPLATE: '陈列手册模板',
    DISPLAY_ELEMENT: '显示元素',
    DISPLAY_ITEM_NAME: '陈列项目名称',
    DISPLAY_PROPS: '陈列道具',
    DISPLAY_THEME: '陈列主题',
    DOCUMENT: '的文件',
    DOCUMENT_LIST: '文档列表',
    DOCUMENT_NUMBER: '文档编号',
    DOCUMENT_TYPE: '文档类型',
    DOWNLOAD_COMPETITIVE_INFORMATION_TEMPLATE: '下载竞品信息模板',
    DOWNLOAD_COMPETITIVE_PRODUCT_CLASSIFICATION_TEMPLATE: '下载竞品分类模板',
    DOWNLOAD_ENTERPRISE_REPAIR_CODE: '下载企业报修码',
    DOWNLOAD_FAILED: '下载失败',
    DOWNLOAD_FEEDBACK_FORM: '下载反馈表格',
    DOWNLOAD_IMPORT_TEMPLATE: '下载导入模板',
    DOWNLOAD_INVENTORY_TEMPLATE: '下载库存模板',
    DOWNLOAD_LINK: '下载地址',
    DOWNLOAD_PRODUCT_CLASSIFICATION_TEMPLATE: '下载商品分类模板',
    DOWNLOAD_PRODUCT_INFORMATION_TEMPLATE: '下载商品信息模板',
    DOWNLOAD_PROP_CLASSIFICATION_TEMPLATE: '下载分类模板',
    DOWNLOAD_PROP_TEMPLATE: '下载道具模板',
    DOWNLOAD_REPAIR_CLASSIFICATION_TEMPLATE: '下载维修分类模板',
    DOWNLOAD_REPAIR_FAILURE_TEMPLATE: '下载维修故障模板',
    DOWNLOAD_SHOP_REPAIR_CODE: '下载店铺报修码',
    DOWNLOAD_STORE_PROPS_TEMPLATE: '下载店铺道具模板',
    DOWNLOAD_SUCCESSFUL: '下载成功',
    DOWNLOAD_TEMPLATE: '下载模板',
    DROP_DOWN_BOX_FOR_ALL_OPTIONAL_LABELS: '下拉框中为所有的可选标签',
    DUPLICATE_CATEGORY_NAMES_IN_EXCEL_ARE_DUPLICATED: 'Excel中竞品分类名称重复;',
    DUPLICATE_NAMES: '名称重复;',
    DUPLICATE_ORGANIZATION_NAMES_IN_EXCEL: 'Excel中组织名称重复;',
    worker_common_000008: 'Excel中组织名称重复;',
    DUPLICATE_PRODUCT_NAME: '商品名称重复;',
    DUPLICATE_PRODUCT_NAMES_IN_EXCEL: 'Excel中商品名称重复;',
    DUPLICATE_THE_SAME_SHOP_NAME_IN_EXCEL: 'Excel中同店铺名称重复;',
    DUPLICATE_THE_SAME_SHOP_NUMBER_IN_EXCEL: 'Excel中同店铺编号重复;',
    DUPLICATE_USER_PHONE_NUMBER_IN_EXCEL: 'Excel中用户手机号重复;',
    DUPLICATION_OF_GOODS_UNDER_THE_ORGANIZATION: '组织下商品重复;',
    EASY_KNOW_CODE: '易知公司Code',
    EASY_TO_KNOW_CONFIGURATION: '易知配置',
    EASY_TO_KNOW_URL: '易知Url',
    EASY_TO_KNOW_WEBSITE_CODE: '易知网站Code',
    EDIT_BRAND: '修改品牌',
    EDIT_BRAND_TYPE: '修改品牌类型',
    EDIT_DETAILS: '编辑详情',
    EDIT_FAILED_THE_SAME_ORGANIZATION_OR_SHOP_NAME_ALREADY_EXISTS: '修改失败,已存在相同组织或店铺名称',
    EDIT_POSITION: '修改职位',
    EDIT_POST_FAILED: '修改职位失败',
    EDIT_REGION: '修改地区',
    EDIT_SHOP: '修改店铺',
    EDITING_OPTIONS: '编辑选项',
    EDITING_TAGS: '编辑标签',
    EFFECTIVE: '有效',
    EFFECTIVE_DATE: '有效日期',
    EMPLOYEE_SUPERIOR: '员工上级',
    EMPTY_ORGANIZATION_SHOP: '清空组织下店铺',
    ENABLE: '启用',
    ENCODING_CANNOT_BE_EMPTY: '编码不能为空',
    END_DATE: '结束日期',
    END_DATE_CANNOT_BE_LESS_THAN_START_DATE: '结束日期不能小于开始日期',
    END_TIME: '期末时间',
    END_TIME1: '结束时间',
    ENDING_NUMBER: '期末数',
    ENGINEERING_MANAGEMENT: '工程管理',
    m_info_common_000018: '工程管理',
    ENGLISH: '英文',
    ENGLISH_NAME: '英文名称',
    ENTER_1: '输入1',
    ENTER_2: '输入2',
    ENTER_3: '输入3',
    ENTER_4: '输入4',
    ENTER_5: '输入5',
    ENTERPRISE: '企业',
    ENTERPRISE_ANNOUNCEMENT: '企业公告',
    ENTERPRISE_REPAIR_CODE_GENERATION_FAILED: '企业报修码生成失败',
    ENTERPRISE_SHARING: '企业共享',
    m_info_common_000035: '企业共享',
    ENTRIES_FAIL_TO_SUBMIT_QUESTIONS: '条目不通过必须提交问题',
    ENTRY_CATEGORY_CANNOT_BE_EMPTY: '条目分类不能为空;',
    ENTRY_NAME: '条目名称',
    ENTRY_NAME_CANNOT_BE_EMPTY: '条目名称不能为空;',
    ENTRY_NUMBER: '条目序号',
    EQUIPMENT_MODEL: '设备型号',
    EQUIPMENT_QUANTITY: '设备数量',
    EQUIPMENT_TYPE: '设备类型',
    ERROR_WRITING_FILE_TO_HARD_DISK: '写文件到硬盘出错。',
    EXAM_ID: '考试ID',
    EXAM_ID1: '试卷ID',
    EXAM_INFORMATION: '考试信息',
    EXAM_LIST: '考试列表',
    EXAM_NOTES: '试卷备注',
    EXAM_NOTES1: '考试须知',
    EXAMINATION_TIME: '考试时间',
    EXAMINER: '考试人员',
    EXCEED: '超过（',
    EXCEEDS_THE_SIZE_ALLOWED_BY_THE_FORM: '超过表单允许的大小。',
    EXCEL_EXPORT: 'Excel导出',
    EXCEPT_FOR_ARCHIVED_DATA_OTHER_DATA_HAS_BEEN_DELETED_NORMALLY: '除归档数据外,其他数据已正常删除',
    EXCHANGE_RATE_MANAGEMENT: '汇率管理',
    EXCHANGE_RATE_SETTING: '汇率设置',
    EXPAND: '展开',
    EXPIRATION_DATE: '有效期',
    ExcelTemplate_common_000019: '有效期',
    EXPLANATION_OR_NOTE: '解释或备注',
    EXPORT_COMPETING_CATEGORIES: '导出竞品分类',
    EXPORT_COMPETITION: '导出竞品',
    EXPORT_DATA: '导　出　选　中　数　据',
    EXPORT_DATA_UNDER_THE_CURRENT_QUERY_CONDITIONS: '导出当前查询条件下数据',
    EXPORT_DISPLAY_BROCHURE: '导出陈列手册',
    EXPORT_EXCEL: '导出Excel',
    EXPORT_FAILED: '导出失败!',
    EXPORT_INSPECTION_TOUR: '导出巡店检查',
    EXPORT_MULTIPLE_LANGUAGES: '导出多语言',
    EXPORT_PEOPLE_EXCEL: '导出人员Excel',
    EXPORT_PREVIEW: '导出预览',
    EXPORT_PRODUCT: '导出商品',
    EXPORT_PRODUCT_CATEGORIES: '导出商品分类',
    EXPORT_PROP_CLASSIFICATION: '导出道具分类',
    EXPORT_PROPS: '导出',
    EXPORT_RETAIL_TOUR: '导出零售巡店',
    EXPORT_STAFF_TO_EXCEL: '导出人员任职Excel',
    EXTENDED_FIELD_01: '拓展字段01',
    EXTENDED_FIELD_02: '拓展字段02',
    EXTENDED_FIELD_03: '拓展字段03',
    EXTENDED_FIELD_04: '拓展字段04',
    EXTENDED_FIELD_05: '拓展字段05',
    EXTENDED_FIELD_06: '拓展字段06',
    EXTENDED_FIELD_07: '拓展字段07',
    EXTENDED_FIELD_08: '拓展字段08',
    EXTENDED_FIELD_09: '拓展字段09',
    EXTENDED_FIELD_10: '拓展字段10',
    EXTENDED_FIELD_11: '拓展字段11',
    EXTENDED_FIELD_12: '拓展字段12',
    EXTENDED_FIELD_13: '拓展字段13',
    EXTENDED_FIELD_14: '拓展字段14',
    EXTENDED_FIELD_15: '拓展字段15',
    EXTENDED_FIELD_16: '拓展字段16',
    EXTENDED_FIELD_17: '拓展字段17',
    EXTENDED_FIELD_18: '拓展字段18',
    EXTENDED_FIELD_19: '拓展字段19',
    EXTENDED_FIELD_20: '拓展字段20',
    FAIL_TO_EDIT: '修改失败',
    FAIL_TO_EDIT1: '修改失败，',
    FAIL_TO_EDIT2: '修改失败:',
    FAILED_THE_TEMPLATE_NAME_ALREADY_EXISTS: '失败:该模板名称已经存在',
    FAILED_TO_ADD_A_QUESTION_BANK_QUESTION: '添加题库问题失败',
    FAILED_TO_ADD_BRAND_TYPE: '添加品牌类型失败',
    FAILED_TO_ADD_ITEM_CATEGORY: '添加道具类别失败',
    FAILED_TO_ADD_JOB: '添加职位失败',
    FAILED_TO_ADD_ORGANIZATION_LEVEL_HAS_REACHED_THE_UPPER_LIMIT: '添加失败，组织层级已达上限',
    FAILED_TO_ADD_OTHER_ADJUSTMENT_FACTORS_EXIST_IN_THE_STARTTOEND_TIME_PERIOD: '添加失败,开始到结束时间段中存在其他调整系数',
    FAILED_TO_ADD_PRODUCT_CATEGORY: '添加商品类别失败',
    FAILED_TO_ADD_REGION: '添加地区失败',
    FAILED_TO_ADD_ROLE: '添加角色失败',
    FAILED_TO_ADD_ROLE1: '添加角色失败,',
    FAILED_TO_ADD_SALES_DATA: '添加销售数据失败',
    FAILED_TO_ADD_STORE_TYPE: '添加店铺类型失败',
    FAILED_TO_ADD_TASK_TYPE: '添加任务类型失败',
    FAILED_TO_ADD_THE_PROBLEM_DESCRIPTION_DOES_NOT_EXCEED_1000_WORDS: '添加失败，问题描述不超过1000字',
    FAILED_TO_ADD_THE_TRANSFER_LABEL: '添加交接本标签失败',
    FAILED_TO_DELETE: '删除失败！',
    FAILED_TO_DELETE_BRAND_TYPE: '删除品牌类型失败',
    FAILED_TO_DELETE_CANNOT_DELETE_THE_STORE: '删除失败,不可删除店铺',
    FAILED_TO_DELETE_COMMON_DATA: '删除通用数据失败',
    FAILED_TO_DELETE_CUSTOM_FIELD: '删除自定义字段失败',
    FAILED_TO_DELETE_DEALER_TYPE: '删除经销商类型失败',
    FAILED_TO_DELETE_DEFECTIVE_PARTS: '删除次品配件失败',
    FAILED_TO_DELETE_DEFECTIVE_PRODUCT: '删除次品问题失败',
    FAILED_TO_DELETE_DEFECTIVE_PRODUCT_CLASSIFICATION: '删除次品问题分类失败',
    FAILED_TO_DELETE_DOCUMENT: '删除文档失败',
    FAILED_TO_DELETE_FILE_TYPE: '删除文件类型失败',
    FAILED_TO_DELETE_JOB: '删除职位失败',
    FAILED_TO_DELETE_MAINTENANCE_ISSUE: '删除维修问题失败',
    FAILED_TO_DELETE_MAINTENANCE_PROBLEM_CLASSIFICATION: '删除维修问题分类失败',
    FAILED_TO_DELETE_PERSON: '删除人员失败',
    FAILED_TO_DELETE_PURCHASE_RECORD: '删除购买记录失败',
    FAILED_TO_DELETE_REGION: '删除地区失败',
    FAILED_TO_DELETE_ROLE: '删除角色失败',
    FAILED_TO_DELETE_STORE: '删除店铺失败',
    FAILED_TO_DELETE_STORE_ATTACHMENT: '删除店铺附件失败',
    FAILED_TO_DELETE_STORE_TYPE: '删除店铺类型失败',
    FAILED_TO_DELETE_STORE_VENDOR: '删除店铺供应商失败',
    FAILED_TO_DELETE_TASK_TYPE: '删除任务类型失败',
    FAILED_TO_DELETE_THE_STORE_CAMERA: '删除店铺摄像头失败',
    FAILED_TO_DELETE_THE_TRANSFER_BOOK: '删除交接本失败',
    FAILED_TO_DELETE_THERE_ARE_ITEMS_USED_IN_THE_ORGANIZATION_NODE_DETAILS_IN_THE_DELETED_ITEMS: '删除失败,删除项中存在组织节点明细中使用的项',
    FAILED_TO_DELETE_THERE_ARE_ITEMS_USED_IN_THE_ORGANIZATIONAL_STRUCTURE_SETTING_IN_THE_DELETED_ITEMS: '删除失败,删除项中存在组织结构设定中使用的项',
    FAILED_TO_DELETE_THERE_IS_AN_ITEM_USED_IN_THE_ROLE_SETTING_IN_THE_DELETED_ITEM: '删除失败,删除项中存在角色设定中使用的项',
    FAILED_TO_DELETE_THIS_CATEGORY: '删除交接本分类失败',
    FAILED_TO_DELETE_TRACKING: '删除货品追踪失败',
    FAILED_TO_DELETE_USER_REFERENCE: '删除用户参照失败',
    FAILED_TO_DELETE_VENDOR_TYPE: '删除供应商类型失败',
    FAILED_TO_DELETE_VISUAL_DISPLAY_ITEM: '删除视觉陈列项目失败',
    FAILED_TO_DELETE_VISUAL_DISPLAY_ITEM_DETAILS: '删除视觉陈列项目明细失败',
    FAILED_TO_DELETE1: '删除失败:',
    FAILED_TO_DELETE2: '删除失败',
    FAILED_TO_GET_THE_FILE_CORRESPONDING_TO_THIS_ID_PLEASE_CONTACT_THE_ADMINISTRATOR: '该ID对应文件获取失败，请联系管理员',
    FAILED_TO_LOAD: '加载失败',
    FAILED_TO_MODIFY_BRAND: '修改品牌失败',
    FAILED_TO_MODIFY_BRAND_TYPE: '修改品牌类型失败',
    FAILED_TO_MODIFY_COMPETITION_CATEGORY: '修改竞品类别失败',
    FAILED_TO_MODIFY_CUSTOM_FIELDS: '修改自定义字段失败',
    FAILED_TO_MODIFY_DEFECTIVE_PARTS: '修改次品配件失败',
    FAILED_TO_MODIFY_DEFECTIVE_PRODUCT: '修改次品问题失败',
    FAILED_TO_MODIFY_FORM_PERMISSIONS: '修改表单权限失败',
    FAILED_TO_MODIFY_GENERAL_DATA: '修改通用数据失败',
    MODIFYING_GENERAL_DATA_FAILED: '修改通用数据失败',
    FAILED_TO_MODIFY_ITEM_CATEGORY: '修改道具类别失败',
    FAILED_TO_MODIFY_MAINTENANCE_ISSUES: '修改维修问题失败',
    FAILED_TO_MODIFY_PRODUCT_CATEGORY: '修改商品类别失败',
    FAILED_TO_MODIFY_PURCHASE_RECORD: '修改购买记录失败',
    FAILED_TO_MODIFY_ROLE: '修改角色失败',
    FAILED_TO_MODIFY_ROLE_PERMISSIONS: '修改角色权限失败',
    FAILED_TO_MODIFY_SALES_DATA: '修改销量数据失败',
    FAILED_TO_MODIFY_STORE: '修改店铺失败',
    FAILED_TO_MODIFY_STORE_CAMERA: '修改店铺摄像头失败',
    FAILED_TO_MODIFY_STORE_EQUIPMENT: '修改店铺设备失败',
    FAILED_TO_MODIFY_STORE_TYPE: '修改店铺类型失败',
    FAILED_TO_MODIFY_TASK_TYPE: '修改任务类型失败',
    FAILED_TO_MODIFY_THE_CLASSIFICATION_OF_DEFECTIVE_PRODUCTS: '修改次品问题分类失败',
    FAILED_TO_MODIFY_THE_PHONE_NUMBER_IS_ALREADY_USED: '修改失败,该手机号已有人使用',
    FAILED_TO_MODIFY_THE_TRANSFER_OF_THIS_LABEL: '修改交接本标签失败',
    FAILED_TO_RESET_PASSWORD: '重置密码失败',
    FAILURE: '失败',
    FAILURE_ONLY_BMP__JPG__JPEG__PNG_FORMAT_PHOTOS_ARE_CURRENTLY_SUPPORTED: '失败:目前仅支持BMP/JPG/JPEG/PNG格式照片',
    FAILURE_TO_ADD_MAINTENANCE_PROBLEM_CLASSIFICATION: '添加维修问题分类失败',
    FAILURE_TO_MODIFY_MAINTENANCE_PROBLEM_CLASSIFICATION: '修改维修问题分类失败',
    FAILURE1: '失败:',
    FEATURES_ARE_NOT_OPEN_YET: '　　功能暂未开放',
    FEMALE: '女',
    infoapi_common_000022: '女',
    FIELD_NAME: '字段名称',
    FIELD_NOTES: '字段备注',
    FIELD_NUMBER: '字段编号',
    FILE: '文件',
    FILE_CATEGORY: '文件类别',
    FILE_EXTENSION: '文件扩展名',
    FILE_EXTENSION_CANNOT_BE_EMPTY: '文件扩展名不能为空',
    FILE_FORMAT_ERROR_UPLOAD_FAILED: '文件格式有误，上传失败',
    FILE_LINK_WILL_BE_DISPLAYED_AFTER_SAVING: '将在保存后显示文件链接',
    FILE_NAME: '文档名称',
    FILE_NAME_CANNOT_BE_EMPTY: '文件名称不可为空',
    FILE_NAME1: '文件名:',
    FILE_NAME2: '文件名称',
    FILE_SIZE: '文件大小',
    FILE_TITLE: '文件标题',
    FILE_TITLE_CANNOT_BE_EMPTY: '文件标题不能为空',
    FILE_TYPE: '文件类型',
    FILE_TYPE_INFORMATION: '文件类型信息',
    FILE_TYPE_NAME: '文件类型名称',
    FILE_UPLOAD_FAILED: '上传文件失败。',
    FILTER_ROLES: '筛选角色',
    FIND: '查找',
    FIRST_WEEK_OF_EACH_YEAR: '每年第一周',
    FIX_DEFECTIVE_PRODUCTS: '修改次品问题',
    FIX_MAINTENANCE_ISSUES: '修改维修问题',
    FIXED_PASSWORD: '固定密码',
    FIXED_PASSWORD_CANNOT_BE_EMPTY: '固定密码不能为空',
    FLOOR_PLAN_FILE_ID_FORMAT_ERROR: '平面图文件Id格式错误;',
    FLOOR_PLAN_TITLE_CANNOT_BE_EMPTY: '平面图标题不能为空;',
    FOLDER__FILE: '文件夹/文件',
    FOR_GROUP_MESSAGING_YOU_MUST_SELECT_AN_ORGANIZATION: '群发消息，必须选择组织。',
    FORCED_DISPLAY_OF_TOTAL_SCORE: '总分强制显示值',
    FORMAT: '格式。',
    FORWARD_NEWS: '推送消息',
    FOUNDER: '创建人',
    FREEZE: '冻结',
    FREEZE_SUCCESSFULLY: '成功冻结',
    FRIDAY: '周五',
    FROZEN: '已冻结',
    FULL_MARK_SETTING: '满分设置',
    FULL_VALUE: '满分值',
    GENDER: '性别',
    ExcelTemplate_common_000017: '性别',
    GENERAL_COMMENT: '总评',
    GENERAL_DATA_DICTIONARY: '通用数据字典',
    GENERAL_DATA_INFORMATION: '通用数据信息',
    GENERAL_USER: '普通用户',
    GENERATE_ENTERPRISE_REPAIR_SPECIALIST: '生成企业报修专员',
    GENERATE_REPAIR_CODE: '生成报修码',
    GENERATED_SUCCESSFULLY: '生成成功',
    GENERATION_OF_MAINTENANCE_CODE_SOME_SELECTED_SHOPS_DO_NOT_HAVE_A_SHOP_NUMBER_AND_CANNOT_GENERATE_REPAIR_CODES: '维修码生成中。选中的部分店铺没有店铺编号，无法生成报修码',
    GET_VERIFICATION_CODE: '获取验证码',
    GOODS_TRACKING: '货品追踪',
    m_info_common_000006: '货品追踪',
    GREETING_RETURN_VISIT_TEMPLATE: '问候回访模板',
    GREETINGS_RETURN_VISIT_DATA_IMPORT: '问候回访数据导入',
    HAND_HELD_MACHINE: '手　　机',
    HAND_OVER_THIS: '交接本',
    m_info_common_000029: '交接本',
    HAVE: '有',
    HAVE_READ: '是否已读',
    HIDDEN_DAYS: '隐藏天数',
    HIDE_SCORE: '隐藏分数',
    HIGH_STRENGTH: '高强度',
    HISTORICAL_EXCHANGE_RATE_SETTINGS: '历史汇率设置',
    HOBBY: '爱好',
    HOUR: '小时',
    IDENTIFY: '识别',
    IF_THE_SIGN_USER_AGREEMENT_OPTION_IS_CHECKED_THE_USER_AGREEMENT_FILE_MUST_BE_UPLOADED: '如果选中签署用户协议选项，必须上传用户协议文件',
    IF_YOU_MODIFY_THE_TEMPLATE_ALL_UNSUBMITTED_TEMPLATES_WILL_NEED_TO_BE_REEDITED_ARE_YOU_SURE_YOU_WANT_TO_MODIFY_IT: '如果修改模板,所有未提交的模板则需要重新编辑,您确认修改吗？',
    IMAGE: '图片',
    IMAGES_WERE_ONLY_PARTIALLY_UPLOADED: '图片只有部分被上传。',
    IMPORT: '导入',
    IMPORT_AREA: '导入地区',
    IMPORT_ASSISTANT: '导入助手',
    IMPORT_BASIC_DATA: '导入基础数据',
    IMPORT_BRAND: '导入品牌',
    IMPORT_COMPETING_CATEGORIES: '导入竞品分类',
    IMPORT_COMPETITION_INFORMATION: '导入竞品信息',
    IMPORT_CUSTOMER: '导入客户',
    IMPORT_DATA: '导入数据',
    IMPORT_DEALER: '导入经销商',
    IMPORT_DISPLAY_BROCHURE: '导入陈列手册',
    IMPORT_DISPLAY_BROCHURE_CONFIGURATION: '导入陈列手册配置',
    IMPORT_DISPLAY_BROCHURE_RELATIONSHIP: '导入陈列手册关系',
    IMPORT_EXCEL: '导入Excel',
    IMPORT_FAILED: '导入失败：',
    IMPORT_FILE_NAME: '导入文件名',
    IMPORT_FILE_SIZE_CANNOT_EXCEED: '导入文件大小不能超过',
    IMPORT_GOODS: '导入货品',
    IMPORT_GREETING_RETURN_VISIT: '导入问候回访',
    IMPORT_INSPECTION_TOUR: '导入巡店检查',
    IMPORT_INVENTORY: '导入库存',
    IMPORT_ITEM_CLASSIFICATION: '导入分类',
    IMPORT_MAINTENANCE_CLASSIFICATION: '导入维修分类',
    IMPORT_MAINTENANCE_FAILURE: '导入维修故障',
    IMPORT_ORGANIZATION: '导入组织',
    IMPORT_PASSENGER_FLOW_CHANNEL: '导入客流通道',
    IMPORT_PRODUCT_CATEGORIES: '导入商品分类',
    IMPORT_PRODUCT_INFORMATION: '导入商品信息',
    IMPORT_PROFESSIONAL_STORE_WITH_SHOP_TEMPLATE: '导入职店带店模板',
    IMPORT_PROGRESS: '导入进度',
    IMPORT_PROPS: '导入',
    IMPORT_PURCHASE_RECORDS: '导入购买记录',
    IMPORT_ROLES: '导入角色',
    IMPORT_SALES: '导入销量',
    IMPORT_SHOP: '导入店铺',
    IMPORT_SHOP_EQUIPMENT: '导入店铺设备',
    IMPORT_SHOP_ITEMS: '导入店铺道具',
    IMPORT_STAFF: '导入人员任职',
    IMPORT_STAFF_ASSESSMENT_TEMPLATE: '导入人员考核模板',
    IMPORT_STATUS: '导入状态',
    IMPORT_SUCCEEDED: '导入成功',
    IMPORT_SUPPLIER: '导入供应商',
    IMPORT_TIME: '导入时间',
    IMPORT_TYPE: '导入类型',
    IMPORTER: '导入人员',
    INBOUND_TRAFFIC: '导入客流',
    INCORRECT_DATA: '数据有误',
    INCORRECT_TIME_FORMAT: '时间格式有误',
    INCORRECT_TIME_RANGE: '时间范围有误',
    INCORRECT_USERNAME_OR_VERIFICATION_CODE: '用户名或验证码错误',
    INDEX: '索引',
    INDUSTRY: '所属行业',
    INFORMATION: '提示信息',
    INPUT_VALUE_TYPES_DO_NOT_MATCH: '输入值类型不匹配;',
    INQUIRE: '查询',
    INSERT_PICTURE: '插入图片',
    INTERNAL_ERROR_DO_YOU_DOWNLOAD_AND_VIEW_THE_PROMPT_FILE: '内部错误，是否下载查看提示文件？',
    INTERNAL_ERROR_PLEASE_VERIFY: '内部错误,请校验',
    INVALID_ATTACHMENT_ID_FORMAT: '无效的附件id格式',
    INVALID_DATE_FORMAT: '无效的日期格式',
    INVALID_ID: '无效的ID',
    INVALID_MANUAL_ID_FORMAT: '无效的手册id格式',
    INVALID_NAME: '无效的名称;',
    INVALID_NUMBER: '无效的编号;',
    INVALID_OPERATION_NO_JOBS_IN_THIS_AREA: '操作无效，该地区没有职位',
    INVALID_OPERATION_THIS_ROLE_HAS_NO_REGION_SELECTION: '操作无效，该角色没有地区选择',
    INVALID_ORGANIZATION: '无效的组织;',
    INVALID_PRIMARY_KEY_ID_FORMAT: '无效的主键id格式',
    INVALID_PRODUCT: '无效的产品;',
    INVALID_SERVICE_CODE: '无效的服务代码',
    INVALID_STORE_ID_FORMAT: '无效的店铺Id格式',
    INVALID_SUPERIOR: '无效的上级;',
    INVENTORY_DATA_IMPORT: '库存数据导入',
    IP_ADDRESS: 'IP地址',
    IS_REQUIRED: '是否必填',
    ISSUE_CATEGORY_INFORMATION_EDIT: '问题类别信息编辑',
    ISSUE_INFORMATION_EDITING: '问题信息编辑',
    ISSUE_NUMBER: 'Issue数量',
    ISSUE_NUMBER1: '问题序号',
    ITEM_CATEGORY: '道具类别',
    ITEM_CATEGORY_INFORMATION: '类别信息',
    ITEM_CATEGORY_SETTINGS: '道具类别设定',
    ITEM_CLASSIFICATION: '道具分类',
    ITEM_CLASSIFICATION_DOES_NOT_EXIST: '道具分类不存在;',
    ITEM_CLASSIFICATION_IMPORT: '道具分类导入',
    ITEM_CODE_CANNOT_BE_EMPTY: '道具编码不能为空;',
    ITEM_CODES_CANNOT_BE_REPEATED_UNDER_THE_SAME_ITEM_CATEGORY: '同一道具分类下道具编码不能重复;',
    ITEM_CORRESPONDING_SUPPLIER_DOES_NOT_EXIST: '道具对应供应商别称不存在',
    ITEM_DESCRIPTION: '条目描述',
    ITEM_INFORMATION: '道具信息',
    ITEM_INFORMATION_MANAGEMENT: '道具信息管理',
    ITEM_NAME: '道具名称',
    ITEM_NAME_CANNOT_BE_EMPTY: '道具名称不能为空;',
    ITEM_NAMES_CANNOT_BE_DUPLICATED_UNDER_THE_SAME_ITEM_CATEGORY: '同一道具分类下道具名称不能重复;',
    ITEM_NUMBER: '道具编号',
    ITEM_NUMBER_DOES_NOT_EXIST: '道具编号不存在',
    ITEM_REPAIR: '道具维修',
    ITEM_UNITS_CANNOT_BE_EMPTY: '道具单位不能为空;',
    JAPANESE: '日文',
    JOB_DETAILS: '职位详情',
    JOB_INFORMATION: '职位信息',
    JOB_INFORMATION1: '的职位信息',
    JOB_SHOP_PROJECT_MANAGEMENT: '职店项目管理',
    m_info_common_000009: '职店项目管理',
    JOB_SHOP_TEMPLATE: '职店模板',
    JOB_TITLE: '职位名称',
    JOB_TITLE1: '职位名称:',
    KEYWORD_SEARCH: '关键字搜索',
    KOREAN: '韩文',
    KPI_MANAGEMENT: 'KPI管理',
    m_info_common_000015: 'KPI管理',
    LABEL: '标签',
    LABEL_1: '标签1',
    LABEL_2: '标签2',
    LABEL_3: '标签3',
    LABEL_INFORMATION: '标签信息',
    LABEL_NAME: '标签名称',
    LANGUAGE_SELECTION: '语言选择',
    LAST_LOGIN_TIME: '最后登录时间',
    LAST_NAME: '姓　　名',
    LAST_RENOVATION_TIME: '最近装修时间',
    LAST_UPDATE_TIME: '最后更新时间',
    LAST_UPDATED: '最近更新时间',
    LAST_UPDATED_BY: '最后更新人',
    LEARNER: '学习人',
    LEARNING_RECORD: '学习记录',
    LEAVE_BLANK: '留空数量',
    LIMIT: '限制',
    LIMIT_SET_THE_MAXSIZE_PROPERTY_TO_CHANGE_THE_LIMIT: '限制!可设置MaxSize属性来改变限制!',
    LINK_ADDRESS: '链接地址',
    LINKED: '已关联',
    LIST_OF_CONTROLS: '控件列表',
    LIST_OF_SHOPS: '店铺列表',
    LOADING: '加载中',
    LOCALE: '地区设定',
    LOCATION_INFORMATION_EDITING: '部位信息编辑',
    LOCKING: '锁定',
    LOG_IN: '登录',
    LOGIN_PROTECTION: '登陆保护',
    LOGIN_TO_THE_INFORMATION_MANAGEMENT_PLATFORM: '登陆了信息管理平台',
    LONG_TERM_EFFECTIVE: '长期有效',
    LOVE: '爱　　好',
    LUMP_SUM: '总额',
    M: '客户类别',
    MAIL_BOX: '邮　　　箱',
    MAIL_CONFIGURATION: '邮件配置',
    MAILBOX: '邮箱',
    ExcelTemplate_common_000020: '邮箱',
    MAIN_PICTURE: '是否主图',
    MAINTENANCE_AUTHORITY: '维修权限',
    MAINTENANCE_AUTHORIZATION_MANAGEMENT: '维修授权管理',
    MAINTENANCE_CATEGORY_SETTING: '维修类别设定',
    MAINTENANCE_CLASSIFICATION: '维修分类',
    MAINTENANCE_CLASSIFICATION_IMPORT: '维修分类导入',
    MAINTENANCE_DATA_DICTIONARY: '维修数据字典',
    MAINTENANCE_FAULT_CLASSIFICATION: '维修故障分类',
    MAINTENANCE_FAULT_CLASSIFICATION_DOES_NOT_EXIST: '维修故障分类不存在;',
    MAINTENANCE_FAULT_CLASSIFICATION_ENGLISH_NAME: '维修故障分类英文名称',
    MAINTENANCE_FAULT_CLASSIFICATION_INFORMATION: '维修故障分类信息',
    MAINTENANCE_FAULT_CLASSIFICATION_NAME: '维修故障分类名称',
    MAINTENANCE_FAULT_IMPORT: '维修故障导入',
    MAINTENANCE_FAULT_NAME: '维修故障名称',
    MAINTENANCE_INFORMATION_MANAGEMENT: '维修信息管理',
    MAINTENANCE_SUPPLIER_DATA_IMPORT: '维修供应商数据导入',
    MAJOR_CATEGORY_DOES_NOT_EXIST: '大类不存在;',
    MALE: '男',
    infoapi_common_000023: '男',
    MALFORMED_BIRTH_YEAR: '出生年份格式有误;',
    MANAGE_EXISTING_TAGS: '管理现有标签',
    MANUAL_UPLOAD_FILE_CANNOT_BE_LARGER_THAN_20M: '手动上传文件不能大于20M',
    MANUAL_UPLOAD_FILE_CANNOT_BE_LARGER_THAN_40M: '手动上传文件不能大于40M',
    MASS_SEND: '群发',
    MATTER_IS_WITHIN_THE_REQUIRED_DATE_RANGE: '事项在第几天必须阶段日期范围内',
    MATTER_MUST_BE_NUMERIC_ON_THE_FIRST_FEW_DAYS: '事项在第几天必须为数字类型',
    MATTERS_MUST_BE_GREATER_THAN_0_ON_THE_FIRST_FEW_DAYS: '事项在第几天必须大于0',
    MECHANISM_1_CONTAINS_THE_WEEK_OF_JANUARY_1: '机制1：包含1月1日的周',
    MECHANISM_2_WEEK_CONTAINING_1_FIRST_THURSDAY: '机制2：包含1第一个周四的周',
    MESSAGE_ADDED: '消息添加',
    MESSAGE_ADDITION_FAILED: '消息添加失败',
    MESSAGE_CENTER: '消息中心',
    MESSAGE_CODE: '消息代码',
    MESSAGE_CONTENT: '消息内容',
    MESSAGE_DELETION: '消息删除',
    MESSAGE_NOTIFICATION: '消息提醒',
    MESSAGE_TYPE: '消息类型',
    MOBILE_PHONE: '手机',
    MODE_OF_OPERATION: '经营方式',
    MODIFICATION_FAILED_BIRTH_TIME_CANNOT_EXCEED_CURRENT_TIME: '修改失败,出生时间不能超过当前时间',
    MODIFICATION_FAILED_BUSINESS_START_TIME_CANNOT_BE_LESS_THAN_END_TIME: '修改失败,营业起始时间不能小于结束时间',
    MODIFICATION_FAILED_CANNOT_BE_MODIFIED_TO_AN_EXISTING_NONCUSTOM_ORGANIZATION: '修改失败,不可修改为已有的非自定义组织',
    MODIFICATION_FAILED_OTHER_ADJUSTMENT_FACTORS_EXIST_IN_THE_STARTTOEND_TIME_PERIOD: '修改失败,开始到结束时间段中存在其他调整系数',
    MODIFICATION_OF_COMPETITION_CATEGORY_SUCCEEDED: '修改竞品类别成功',
    MODIFICATION_OF_RETAIL_TOUR_TEMPLATE: '修改零售巡店模板问题',
    MODIFY: '修改',
    MODIFY_ASSET_FAILED: '修改资产失败',
    MODIFY_ASSET_TYPE: '修改资产类型',
    MODIFY_ASSET_TYPE_FAILED: '修改资产类型失败',
    MODIFY_ASSETS: '修改资产',
    MODIFY_CLASSIFICATION: '修改分类',
    MODIFY_COURSE: '修改课程',
    MODIFY_COURSEWARE: '修改课件',
    MODIFY_DEALER: '修改经销商',
    MODIFY_DEALER_TYPE: '修改经销商类型',
    MODIFY_DEFECTIVE_PARTS: '修改次品配件',
    MODIFY_DISPLAY_MANUAL_AND_ROLE_ASSOCIATION: '修改陈列手册与角色关联',
    MODIFY_FAILED_ILLEGAL_OPERATION: '修改失败,非法操作',
    MODIFY_FAILED_NO_CORRECT_ANSWER_EXISTS_IN_OPTIONS: '修改失败,选项中不存在正确答案',
    MODIFY_FAILED_PHONE_NUMBER_ALREADY_EXISTS: '修改失败,电话号码已存在',
    MODIFY_FAILED_START_TIME_CANNOT_BE_GREATER_THAN_END_TIME: '修改失败,开始时间不能大于结束时间',
    MODIFY_FAILED_START_TIME_CANNOT_BE_LESS_THAN_TODAY: '修改失败,开始时间不能小于今天',
    MODIFY_FAILED_THE_NUMBER_OF_ORGANIZATIONS_IN_THE_ORGANIZATION_HAS_REACHED_THE_UPPER_LIMIT: '修改失败，该组织下组织数量已达上限',
    MODIFY_FILE_TYPE: '修改文件类型',
    MODIFY_FORM_PERMISSIONS: '修改表单权限',
    MODIFY_GENERAL_DATA: '修改通用数据',
    MODIFY_GREETING_RETURN_VISIT_TYPE: '修改问候回访类型',
    MODIFY_ITEM_CATEGORY_SUCCESSFULLY: '修改道具类别成功',
    MODIFY_ITEM_CLASSIFICATION: '修改道具分类',
    MODIFY_MAINTENANCE_PROBLEM_CLASSIFICATION: '修改维修问题分类',
    MODIFY_MAINTENANCE_ROLE_PERMISSIONS: '修改维修角色权限',
    MODIFY_ORGANIZATION_NODE: '修改组织节点',
    MODIFY_ORGANIZATION_TYPE: '修改组织类型',
    MODIFY_PASSENGER_FLOW: '修改客流',
    MODIFY_PASSENGER_FLOW_CONVERSION_RATE: '修改客流转换率',
    MODIFY_PERSON: '修改人员',
    MODIFY_PERSONNEL_ASSESSMENT_TEMPLATE: '修改人员考核模板',
    MODIFY_PURCHASE_RECORDS: '修改购买记录',
    MODIFY_QUESTION_BANK_QUESTIONS: '修改题库问题',
    MODIFY_REPORT_FIELD_ON_DATA: '修改数据上报表单字段：',
    MODIFY_RETAIL_TOUR_TEMPLATE: '修改零售巡店模板',
    MODIFY_ROLE: '修改角色',
    MODIFY_ROLE_PERMISSIONS: '修改角色权限',
    MODIFY_SALES_DATA: '修改销量数据',
    MODIFY_SHOP_CAMERA: '修改店铺摄像头',
    MODIFY_SHOP_EQUIPMENT: '修改店铺设备',
    MODIFY_STORE_TYPE: '修改店铺类型',
    MODIFY_TASK_TYPE: '修改任务类型',
    MODIFY_TEST_PAPER: '修改试卷',
    MODIFY_THE_ADJUSTMENT_FACTOR: '修改调整系数',
    MODIFY_THE_DEFECTIVE_PRODUCT_CLASSIFICATION: '修改次品问题分类',
    MODIFY_THE_REPORT_ON_THE_DATA: '修改数据上报表单:',
    MODIFY_THE_RETAIL_TOUR_TEMPLATE_PROBLEM_CLASSIFICATION: '修改零售巡店模板问题分类',
    MODIFY_THE_STAFF_ASSESSMENT_TEMPLATE: '修改人员考核模板问题',
    MODIFY_THE_TEST_QUESTION: '修改试卷问题',
    MODIFY_THE_TRANSFER_LABEL: '修改交接本标签',
    MODIFY_USER_REFERENCE: '修改用户参照',
    MODIFY_USER_REFERENCE_FAILED: '修改用户参照失败',
    MODIFYING_CUSTOM_FIELDS: '修改自定义字段',
    MONEY_MANAGEMENT: '货币管理',
    MONTH: '月',
    MORE_CONDITIONS: '更多条件',
    MORE_THAN_1000_WORDS: '字数超过1000字;',
    MULTILINGUAL_SETTINGS: '多语言设置',
    MULTILINGUAL_UPDATE_OF_MAINTENANCE_CLASSIFICATION: '维修分类多语言更新',
    MULTIPLE_CHOICE: '单选题',
    SINGLE_CHOICE: '单选题',
    z_info_common_000002: '单选题',
    MULTIPLE_CHOICE_QUESTIONS: '多选题',
    z_info_common_000003: '多选题',
    MUST_BE_THE_DEFAULT_LANGUAGE_WHEN_ADDING: '新增时必须为默认语言',
    NAME: '姓名',
    ExcelTemplate_common_000008: '姓名',
    NAME_CANNOT_BE_EMPTY: '姓名不能为空！',
    NAME_IS_INVALID: '名称无效;',
    NAME_IS_REQUIRED: '名称不能为空',
    NAME_OF_ASSOCIATION: '组织名称',
    NAME1: '名称',
    NAME2: '名　　称',
    NAME3: '名',
    NEEDS_REVIEW_AND_CONFIRMATION: '需要审核确认',
    NEW_REPORT_FIELDS_ON_DATA: '新增数据上报表单字段：',
    NEW_TYPE: '新类型',
    NO: '否',
    NO_CHANGES: '未做任何修改',
    NO_COMPANY_SELECTED: '未选择公司！',
    NO_CORRESPONDING_DEVICE_CODE_FOUND: '找不到对应的设备码！',
    NO_DATA: '没有数据',
    NO_DATA_DETECTED: '未检测到数据！',
    NO_DATA_IMPORTED: '未导入数据',
    NO_EDITABLE_ITEMS_FOUND: '未找到可修改项',
    NO_FILE_CORRESPONDING_TO_THE_ID: '没有该ID对应的文件',
    NO_PASSWORD_SETTINGS_SELECTED: '未选中任何密码设置',
    NO_REASON_TO_ENTER: '没有该入库原因',
    NO_SUCH_CUSTOMER_POSITION: '无此客户职位;',
    NO_SUCH_ORGANIZATION_TYPE: '没有此组织类型;',
    NO_SUCH_PARENT_ORGANIZATION_NAME: '无该上级组织名称;',
    NO_SUCH_SHOP: '没有此店铺;',
    NO_SUCH_SHOP_NAME: '没有此商铺名称;',
    NO_SUCH_USER_INFORMATION: '无此用户信息;',
    NO_SUPERIOR_USER_INFORMATION: '无上级用户信息;',
    NO_TEMPORARY_DIRECTORY_WAS_FOUND: '找不到临时目录。',
    NO1: '无',
    infoapi_common_000024: '无',
    NON_RETAIL_SYSTEM: '非零售系统',
    NONRETAIL_SYSTEM: '非零售系统',
    infoapi_common_000028: '非零售系统',
    NONE_OF_THE_SELECTED_STORES_HAVE_A_STORE_NUMBER_AND_CANNOT_GENERATE_A_REPAIR_CODE: '选中的店铺全部没有店铺编号，无法生成报修码',
    NOT_CONNECTED_TO_THE_INTERNET: '未连接到互联网',
    NUMBER_OF_ATTACHMENTS: '附件数',
    NUMBER_OF_CATEGORIES: '类别数量',
    NUMBER_OF_COMMENTS: '留言数',
    NUMBER_OF_DAILY_GUESTS: '日客单数',
    NUMBER_OF_ENTRIES: '条目数量',
    NUMBER_OF_FAILED_ITEMS: '不合格项数量',
    NUMBER_OF_INSPECTION_ITEMS: '检查项数量',
    NUMBER_OF_LEVELS_OF_SUPERIOR_ORGANIZATION_PERSONNEL_ALLOWED_TO_VIEW: '允许查看的上级组织人员层数',
    NUMBER_OF_MEMBERS: '成员数',
    NUMBER_OF_N_A_ITEMS: 'N/A项数量',
    NUMBER_OF_PHOTOS: '照片数量',
    NUMBER_OF_PRODUCTS: '产品数',
    NUMBER_OF_QUALIFIED_ITEMS: '合格项数量',
    NUMERIC: '数值型',
    OFFICE_ADDRESS: '办公地址',
    OFFICE_NUMBER: '工作电话',
    OFFICE_PHONE: '办公电话',
    OFFSET_COEFFICIENT: '偏移系数',
    OFFSET_VALUE: '偏移值',
    OK_TO_GENERATE_REPAIR_CODE: '确定生成报修码',
    OK_TO_REFRESH_ALL_SHOP_REPAIR_SPECIALISTS: '确定刷新所有店铺报修专员',
    ON_MONDAY: '周一',
    ON_SATURDAY: '周六',
    ON_TUESDAY: '周二',
    ON_WEDNESDAY: '周三',
    ONLINE_TRAINING: '在线培训',
    ONLY_SELECT_SHOPS: '只可以选择店铺',
    ONLY_WORD_DOCUMENTS_ARE_SUPPORTED: '仅支持word文档',
    OPEN_ADDRESS_BOOK: '开放通讯录',
    OPEN_INQUIRY: '开放询价',
    OPEN_SHOP: '开放店铺',
    OPENING_DATE: '开店日期',
    OPERATION_FAILED: '操作失败',
    OPERATION_IS_INVALID_BIRTH_TIME_CANNOT_EXCEED_CURRENT_TIME: '操作无效，出生时间不能超过当前时间',
    OPERATOR: '操作人',
    OPTION: '选项',
    OPTION_INFORMATION: '选项信息',
    OPTION_MODIFICATION: '选项修改',
    OPTION_OR_CONTENT_CANNOT_BE_EMPTY: '选项或者内容不能为空',
    ORDER: '顺序',
    ORDINARY_STRENGTH: '普通强度',
    ORGANIZATION: '所在组织',
    ORGANIZATION_CODE: '组织编码',
    ORGANIZATION_DATA_IMPORT: '组织数据导入',
    ORGANIZATION_DATA_TEMPLATE: '组织数据模板',
    ORGANIZATION_DIRECTORY: '组织目录',
    ORGANIZATION_HANDOVER: '组织交接本',
    ORGANIZATION_INFORMATION: '组织信息',
    ORGANIZATION_LIST: '组织列表',
    ORGANIZATION_NAME_CANNOT_BE_EMPTY: '组织名称不能为空',
    ORGANIZATION_NAME_CANNOT_BE_EMPTY1: '组织名称不能为空;',
    worker_common_000005: '组织名称不能为空;',
    ORGANIZATION_NAME_CANNOT_BE_EMPTY2: '组织名称不能为空！',
    ORGANIZATION_STRUCTURE_SETTING: '组织结构设定',
    TREE_MENU_DOMAIN_MANAGEMENT: '组织结构设定',
    ORGANIZATION_TYPE: '组织类型',
    ORGANIZATION_TYPE_CANNOT_BE_EMPTY: '组织类型不能为空',
    ORGANIZATION_TYPE_CANNOT_BE_EMPTY1: '组织类型不能为空;',
    ORGANIZATION_TYPE_CANNOT_BE_SHOP: '组织类型不能为店铺;',
    ORGANIZATION_TYPE1: '组织类型:',
    ORGANIZATION1: '组织',
    ORGANIZATION2: '所属组织',
    ORGANIZATIONDEPARTMENT_NAME: '组织/部门名称',
    ExcelTemplate_common_000011: '组织/部门名称',
    OTHER_INFORMATION: '其他信息',
    OUT_OF_STOCK: '本期出库',
    OUTBOUND: '出库',
    OUTBOUNDINBOUND: '出库/入库',
    OUTGOING_NUMBER: '拨出号码',
    OWNED_MALL: '所属商场',
    PARENT_CATEGORY_IS_NOT_LOADED: '上级分类未加载',
    PARENT_FOLDER: '上级文件夹',
    PARENT_ORGANIZATION: '上级组织',
    PART_OF_THE_DATA_IS_IMPORTED_SUCCESSFULLY_DO_YOU_DOWNLOAD_THE_PROMPT_FILE_TO_VIEW_THE_WRONG_DATA: '部分数据导入成功，是否下载提示文件查看错误数据？',
    PASSENGER_CHANNEL: '客流通道',
    PASSENGER_CHANNEL_IMPORT_TEMPLATE: '客流通道导入模板',
    PASSENGER_CHANNEL_INFORMATION: '客流通道信息',
    PASSENGER_DATA_IMPORT: '客流数据导入',
    PASSENGER_DATA_IS_ARCHIVED: '客流数据已归档',
    PASSENGER_DATA_TEMPLATE: '客流数据模板',
    PASSENGER_EQUIPMENT_INFORMATION: '客流设备信息',
    PASSENGER_FLOW_ADJUSTMENT: '客流调整',
    PASSENGER_FLOW_ADJUSTMENT_LIST: '客流调整列表',
    PASSENGER_FLOW_EQUIPMENT: '客流设备',
    PASSENGER_FLOW_INFORMATION: '客流信息',
    PASSENGER_FLOW_INFORMATION_ADDED: '客流信息添加',
    PASSENGER_FLOW_INFORMATION_UPDATE: '客流信息更新',
    PASSENGER_FLOW_MANAGEMENT: '客流管理',
    PASSENGER_FLOW_STATISTICS: '客流统计',
    PASSING_SCORE: '合格得分',
    PASSWORD: '密码',
    PASSWORD_IS_TOO_LONG: '密码长度过长',
    PASSWORD_IS_TOO_SHORT: '密码长度过短',
    PASSWORD_RESET_SUCCEEDED: '重置密码成功',
    PENDING_REVIEW: '待审核',
    PEOPLE_DATA_TEMPLATE: '人员数据模板',
    PEOPLE_LIST: '人员列表',
    PERCENTAGE: '百分比',
    PERFORMANCE_APPRAISAL: '绩效考核',
    m_info_common_000023: '绩效考核',
    PERFORMANCE_APPRAISAL_REPORT: '绩效考评报告',
    PERFORMANCE_APPRAISAL_REPORT1: '绩效考核报告',
    PERFORMANCE_APPRAISAL_TEMPLATE: '绩效考核模板',
    PERMISSION_INFORMATION: '权限信息',
    PERSONAL_INFORMATION: '个人信息',
    PERSONNEL_ASSESSMENT_TEMPLATE_IMPORT: '人员考核模板导入',
    PERSONNEL_INFORMATION: '人员信息',
    PERSONNEL_MANAGEMENT: '人员管理',
    PHASE_ENDS_ON_DAY_OF_DAY_MUST_BE_NUMERIC: '阶段结束于第几天必须为数字类型',
    PHASE_ENDS_ON_DAYS_MUST_BE_GREATER_THAN_0: '阶段结束于第几天必须大于0',
    PHASE_STARTS_ON_DAY_OF_DAY_MUST_BE_NUMERIC: '阶段开始于第几天必须为数字类型',
    PHASE_STARTS_ON_THE_FIRST_FEW_DAYS_AND_MUST_BE_GREATER_THAN_0: '阶段开始于第几天必须大于0',
    PHONE: '电话',
    PHONE_NUMBER: '手机号',
    PHONE_NUMBER_CANNOT_BE_EMPTY: '手机号不能为空！',
    PICTURE_FORMAT_IS_NOT_SUPPORTED: '图片格式不支持',
    PICTURE_UPLOADED_SUCCESSFULLY: '图片上传成功',
    PLANNING_TIME: '计划时间',
    PLEASE_ADD_PASSENGER_FLOW_DATA: '请添加客流数据',
    PLEASE_CHECK_THE_DATA: ',请检查数据',
    PLEASE_CHECK_THE_REQUIRED_FIELDS: '　请勾选需使用的字段',
    PLEASE_CHOOSE: '请选择',
    PLEASE_CHOOSE_TO_UPLOAD_A_FILE: '请选择上传文件！',
    PLEASE_CONFIRM_WHETHER_TO_RESET_THE_SELECTED_USER_PASSWORD: '请确认是否重置所选用户密码？',
    PLEASE_COPY: '请进行复制:　　',
    PLEASE_ENTER_PASSENGER_FLOW_DATA: '请输入客流数据！',
    PLEASE_ENTER_SALES_DATA: '请输入销售数据！',
    PLEASE_ENTER_THE_SERVICE_CODE: '请输入服务代码',
    PLEASE_FILL_IN_THE_ATTACHMENT_CATEGORY_AND_TITLE_AND_CHOOSE_TO_UPLOAD_THE_FILE: '请填写附件类别和标题，并选择上传文件！',
    PLEASE_FILL_IN_THE_INFORMATION_CATEGORY_AND_TITLE_AND_CHOOSE_TO_UPLOAD_THE_FILE: '请填写资料类别和标题，并选择上传文件！',
    PLEASE_FILL_IN_THE_TITLE_AND_CHOOSE_TO_UPLOAD_THE_FILE: '请填写标题，并选择上传文件！',
    PLEASE_SELECT: '请选择启用项',
    PLEASE_SELECT_A_CATEGORY: '请选择竞品分类',
    PLEASE_SELECT_A_CUSTOMER: '请选择客户',
    PLEASE_SELECT_A_DOCUMENT_TO_DOWNLOAD: '请选择需要下载的文档',
    PLEASE_SELECT_A_DOWNLOAD_TEMPLATE: '请选择下载模板',
    PLEASE_SELECT_A_FILE: '请选择文件。',
    PLEASE_SELECT_A_FILE_TO_UPLOAD: '请选择需要上传的文件！',
    PLEASE_SELECT_A_FROZEN_REPAIR_CODE: '请选择冻结的报修码',
    PLEASE_SELECT_A_MODIFICATION: '请选择修改项',
    PLEASE_SELECT_A_NODE: '请选择节点',
    PLEASE_SELECT_A_PARENT_ORGANIZATION: '请选择上级组织',
    PLEASE_SELECT_A_PICTURE: '请选择图片。',
    PLEASE_SELECT_A_PRODUCT_CATEGORY: '请选商品类别',
    PLEASE_SELECT_A_PRODUCT_CATEGORY1: '请选择商品分类',
    PLEASE_SELECT_A_PROP_CATEGORY: '请选道具类别',
    PLEASE_SELECT_A_REPAIR_CATEGORY: '请选择维修类别',
    PLEASE_SELECT_A_SHOP: '请选择店铺',
    PLEASE_SELECT_A_STICKY_ITEM: '请选择置顶项',
    PLEASE_SELECT_A_SUITABLE_PASSWORD_LENGTH: '请选择合适的密码长度',
    PLEASE_SELECT_A_USER: '请选择用户',
    PLEASE_SELECT_AN_ITEM: '请选择删除项',
    PLEASE_SELECT_AN_ITEM_TO_DEACTIVATE: '请选择需要停用的项',
    PLEASE_SELECT_AN_ITEM_TO_UNPIN: '请选择需要取消置顶的项',
    PLEASE_SELECT_AN_ORGANIZATION_NODE: '请选择组织节点',
    PLEASE_SELECT_ASSET_CLASS: '请选择资产类别',
    PLEASE_SELECT_EXPORT_DATA: '请选择导出数据',
    PLEASE_SELECT_ITEM_CATEGORY: '请选择道具类别',
    PLEASE_SELECT_THE_COMPANY_YOU_WANT_TO_LOGIN: '请选择您要登陆的公司',
    PLEASE_SELECT_THE_COMPETITION_CATEGORY: '请选竞品类别',
    PLEASE_SELECT_THE_FROZEN_REPAIR_CODE: '请选择恢复冻结的报修码',
    PLEASE_SELECT_THE_ITEM_CATEGORY: '请选择的道具分类',
    PLEASE_SELECT_THE_ITEM_YOU_WANT_TO_DELETE: '请选择需要删除的项',
    PLEASE_SELECT_THE_ITEM_YOU_WANT_TO_ENABLE: '请选择需要启用的项',
    PLEASE_SELECT_THE_ITEM_YOU_WANT_TO_PIN: '请选择需要置顶的项',
    PLEASE_SELECT_THE_ITEM_YOU_WANT_TO_UNFREEZE: '请选择需要解除冻结的项',
    PLEASE_SELECT_THE_ITEMS_THAT_NEED_TO_BE_FROZEN: '请选择需要冻结的项',
    PLEASE_SELECT_THE_STORE_TO_BE_EDITED: '请选择需要编辑的店铺',
    PLEASE_SELECT_THE_TOPICS_YOU_WANT_TO_ADD: '请选择需要添加的题目',
    PLEASE_SELECT_UNPIN: '请选择取消置顶项',
    PLEASE_SELECT_UPLOAD_FILE: '请选择上传文件',
    PLEASE_SELECT_WHO_YOU_WANT_TO_SEND: '请选择要发送的人员！',
    PLEASE_UPLOAD_A_600_600_PIXEL_IMAGE: '请上传600*600像素的图片',
    PLEASE_UPLOAD_A_COURSEWARE_PICTURE: '请上传课件图片',
    POINT_BOOK_LIST: '点数本列表',
    POSITION: '职位',
    POSITION_MANAGEMENT: '职位管理',
    POSITION_SELECTION: '职位选择:',
    POSITION1: '职　　位',
    POST_FORM: '发布表单:',
    POST_INFORMATION: '跟帖信息',
    POSTCODE: '邮编',
    PRICE: '标价',
    PROBLEM_CATEGORY_NAME: '问题分类名称',
    PROBLEM_DESCRIPTION: '问题描述',
    PROBLEM_INFORMATION: '问题信息',
    PROBLEM_MODIFICATION: '问题修改',
    PROBLEM_NAME: '问题名称',
    PROBLEM_WEIGHT: '问题权重',
    PROCESSING: '进行中',
    PRODUCT_CATEGORY_ADDED_SUCCESSFULLY: '添加商品类别成功',
    PRODUCT_CATEGORY_IMPORT: '商品分类导入',
    PRODUCT_CATEGORY_MODIFIED_SUCCESSFULLY: '修改商品类别成功',
    PRODUCT_CLASSIFICATION_INFORMATION: '商品分类信息',
    PRODUCT_DATA_IMPORT: '商品数据导入',
    PRODUCT_ID: '商品ID',
    PRODUCT_INFORMATION: '商品信息',
    PRODUCT_INFORMATION_IMPORT: '商品信息导入',
    PRODUCT_LEVEL_1_CLASSIFICATION: '产品1级分类',
    PRODUCT_LEVEL_1_CLASSIFICATION_NAME: '产品1级分类名称',
    PRODUCT_NAME: '商品名称',
    PRODUCT_NAME1: '货品名称',
    PRODUCT_NUMBER: '商品编号',
    PROJECT_MANAGER: '工程管理员',
    PROMPT: '提示',
    PROMPT_MESSAGE: '提示消息',
    PROP_DATA_IMPORT: '道具数据导入',
    PROP_DOES_NOT_EXIST: '道具不存在;',
    PROP_IMAGE: '道具图片:',
    PROPS_CATEGORY_PICTURES: '道具分类图片',
    PROVINCE_NAME: '省份名称',
    PUBLIC_DOCUMENT: '公共文件',
    PURCHASE_DATE: '购买日期',
    PURCHASE_HISTORY: '购买记录',
    PURCHASE_INFORMATION: '购买信息',
    PURCHASE_RECORD_IMPORT: '购买记录导入',
    PURCHASE_RECORD_TEMPLATE: '购买记录模板',
    PURCHASE_TIME: '购买时间',
    PURPOSE_OF_RETURN_VISIT: '回访目的',
    PUSH: '推送',
    PUSH_TARGET: '推送目标',
    QUANTITY: '数量',
    QUERY_CONDITIONS: '查询条件',
    QUERY_ORGANIZATION_TAG: '查询组织Tag',
    QUESTION_ANSWER: '题目答案',
    QUESTION_BANK_ADD: '题库添加',
    QUESTION_BANK_MANAGEMENT: '题库管理',
    QUESTION_CATEGORY: '问题分类',
    QUESTION_CODE: '问题Code',
    QUESTION_NUMBER: '试题编号',
    QUESTION_NUMBER1: '问题编号',
    QUESTION_TITLE: '问题标题',
    QUESTION_TYPE: '试题类型',
    QUESTION_TYPE1: '问题类型',
    QUESTIONS_IN_USE_CANNOT_BE_DELETED: '正在使用的问题,不能删除！',
    R_ACADEMY: 'R+学院',
    RANDOM_PASSWORD: '位随机密码',
    RANGE_LIMITATION: '）范围限制;',
    REACHING_THIS_VALUE_THE_SCORES_FOR_THIS_BROAD_CATEGORY_ARE: '达到该值，该大类得分为:',
    RECEIVE_CC: '收件/抄送',
    RECIPIENT: '收件人',
    RECIPIENT_ORGANIZATION: '收信组织',
    RECOGNITION_SUCCESS: '识别成功',
    RECORDING_METHOD: '记录方式',
    REFERENCE_DESCRIPTION: '参照说明',
    REFERENCE_FORM: '参照表单',
    REFRESH: '刷新',
    REFRESH_FAILED: '刷新失败',
    REFRESH_SUCCESSFUL: '刷新成功',
    REFUSE: '拒绝',
    REGION_DATA_TEMPLATE: '地区数据模板',
    REGION_SELECTION: '地区选择',
    REGIONAL_DATA_IMPORT: '地区数据导入',
    REJECTED: '已拒绝',
    RELATED_SHOPS: '相关店铺',
    RELEASE_DATE: '发布日期',
    RELEASE_TIME: '发布时间',
    REMARK: '备　　注',
    REMARK1: '备　　　注',
    REMARK2: '备注',
    REMINDER: '形同提醒',
    REMOVE_BRAND: '删除品牌',
    REMOVE_BRAND_TYPE: '删除品牌类型',
    REMOVE_DEALER: '删除经销商',
    REMOVE_DEALER_TYPE: '删除经销商类型',
    REMOVE_DEFECTIVE_PARTS: '删除次品配件',
    REMOVE_DEFECTIVE_PRODUCT: '删除次品问题',
    REMOVE_DEFECTIVE_PRODUCT_CLASSIFICATION: '删除次品问题分类',
    REMOVE_GPS: '删除GPS',
    REMOVE_ITEM_CATEGORY: '删除道具类别',
    REMOVE_LAND_PASSENGER_CONVERSION_RATE: '删除地客流转换率',
    REMOVE_MAINTENANCE_ISSUES: '删除维修问题',
    REMOVE_RETAIL_TOUR_TEMPLATE: '删除零售巡店模板',
    REMOVE_RETAIL_TOUR_TEMPLATE_ISSUE: '删除零售巡店模板问题',
    REMOVE_STORE_VENDOR: '删除店铺供应商',
    REMOVE_TRACKING: '删除货品追踪',
    REMOVE_VENDOR_TYPE: '删除供应商类型',
    REMOVE_VISUAL_DISPLAY: '删除视觉陈列',
    REPAIR_APPLICATION: '维修申请单',
    REPAIR_CATEGORY: '报修类别',
    REPAIR_CATEGORY_INFORMATION: '维修类别信息',
    REPAIR_CLASSIFICATION: '报修分类',
    REPAIR_CODE: '报修码:',
    REPAIR_CODE_IS_FROZEN: '报修码处于冻结状态',
    REPAIR_CODE_IS_NOT_FROZEN: '报修码没有被冻结',
    REPAIR_CODE_STATUS: '报修码状态',
    REPAIR_FAILURE: '维修故障',
    REPAIR_FAILURE_INFORMATION: '维修故障信息',
    REPAIR_INFORMATION: '维修信息',
    REPAIR_MODULE_CONFIGURATION: '报修模块配置',
    REPAIR_NAME: '维修名称',
    REPLIES: '回复数',
    REPORT_CATEGORY: '报表类别',
    REPORT_CENTER: '报表中心',
    m_info_common_000002: '报表中心',
    REPORT_DATE: '报告日期',
    REPORT_DESCRIPTION: '报表描述',
    REPORT_MANAGEMENT: '报表管理',
    REPORT_NAME: '报表名称',
    REPORT_NUMBER: '报表编号',
    REPORT_PERMISSION_SETTINGS: '报表权限设置',
    REQUEST_CANCELLATION_REPORT_EXPIRY_TIME: '申请取消报告过期时间',
    REQUIRED: '　　　　　　　　　　　　　必填项',
    REQUIRED1: '　　　　　　　　　　　　　　必填项',
    RESELLER_DATA_TEMPLATE: '经销商数据模板',
    RESET: '重置',
    RESET_PASSWORD: '重置密码',
    RESET_PASSWORD_MAIL: '重置密码（邮件）',
    RESET_PASSWORD_SMS: '重置密码（短信）',
    RESTORE: '恢复',
    RESTRICT_ORGANIZATION_INFORMATION: '限制组织信息',
    RESTRICTED_CATEGORY: '限制类别',
    RESTRICTED_ORGANIZATION: '限制组织',
    RESTRICTED_REPAIR_CATEGORIES: '限制报修类别',
    RETAIL_MANAGEMENT: '零售管理',
    RETAIL_TOUR: '零售巡店',
    RETAIL_TOUR_REPORT: '零售巡店报告',
    RETAIL_TOUR_STORE_TEMPLATE: '零售巡店模板',
    RETURN_NAME: '回访名称',
    RETURN_NUMBER: '回访号码',
    RETURN_NUMBER1: '回访编号',
    RETURN_VISIT_DETAILS: '回访详情',
    RETURN_VISIT_GUIDANCE: '回访指导',
    RETURN_VISIT_INFORMATION: '回访信息',
    RETURN_VISIT_PLAN: '回访计划',
    RETURN_VISIT_RECORDS: '回访记录',
    RETURN_VISIT_RESULTS: '回访结果',
    RETURN_VISIT_TIME: '回访时间',
    REVERSE_ORDER: '顺逆序',
    REVERSE_ORDER1: '逆序',
    REVISITED: '回访对象',
    RIGHTS_PROFILE: '权限配置',
    ROLE_DATA_IMPORT: '角色数据导入',
    ROLE_DATA_TEMPLATE: '角色数据模板',
    ROLE_DETAILS: '角色详情',
    ROLE_INFORMATION: '角色信息',
    ROLE_LOOK_UP: '角色（抬头）',
    ROLE_NAME: '角色名称',
    ROLE_NAME_CANNOT_BE_EMPTY: '角色名称不可为空',
    ROLE_NAME_CANNOT_BE_EMPTY1: '角色名称不能为空！',
    ROLE_PERMISSIONS: '角色权限',
    ROLE_SELECTION: '角色选择:',
    ROLE_TEMPLATE_SETTINGS: '角色模板设置',
    ROLES: '角色',
    ExcelTemplate_common_000010: '角色',
    ROLES1: '角　　色',
    RPLUS: '【RPLUS】',
    SAFETY_STOCK: '安全库存',
    SALES_DATA_IMPORT: '销量数据导入',
    SALES_DATA_IS_ARCHIVED: '销售数据已归档',
    SALES_DATA_TEMPLATE: '销量数据模板',
    SALES_INFORMATION: '销售信息',
    SALES_INFORMATION_UPDATE: '销售信息更新',
    SALES_MANAGEMENT: '销量管理',
    SALES_REPORT: '销售上报',
    m_info_common_000038: '销售上报',
    SALES_STATISTICS: '销售统计',
    SAVE: '保存',
    SAVE_FAILED: '保存失败',
    SAVE_THE_CONFIGURATION: '保存配置',
    SAVED_SUCCESSFULLY: '保存成功',
    SCORE: '得分',
    SCORE_DISPLAY: '得分显示',
    SCORE_VALUE: '得分值',
    SCORING_METHOD: '评分方式',
    SCORING_MODE: '评分模式',
    SEARCH_FOR: '搜索',
    SELECT: '选择',
    SELECT_ALL: '全选',
    SELECT_ALL_STORES: '全选组织下店铺',
    SELECT_EMAIL_LANGUAGE: '选择邮件语言',
    SELECT_GOODS: '选择货品',
    SELECT_IMAGE: '选择图片',
    SELECT_SHOP: '选择商铺',
    SELECT_SUPERIOR: '选择上级',
    SELECTED_ANSWER: '所选答案',
    SELECTED_NODE_ID: '选中节点ID：',
    SELECTIVE: '选择型',
    SEND: '发送',
    SEND_DATE: '发送日期',
    SEND_HEADER_CANNOT_BE_EMPTY: '发送标题不可为空！',
    SEND_MESSAGES: '发送消息',
    SEND_SIGNATURE_CANNOT_BE_EMPTY: '发送签名不可为空！',
    SENDER: '发送人',
    SENDER1: '发信人',
    SENDING_CONTENT_CANNOT_BE_EMPTY: '发送内容不可为空！',
    SEQUENCE_NUMBER: '序　　号',
    SERIAL_NUMBER: '序号',
    SERIAL_NUMBER1: '流水号',
    SERVE: '任职',
    SERVICE_CODE: '服务代码',
    SERVICE_TYPE: '服务类型',
    SERVICE_TYPE1: '服务类型：',
    SET_AS: '设置为',
    SET_CURRENCY: '设置货币',
    SET_FAULT_CLASSIFICATION: '设置故障分类',
    SET_ROLE: '设置角色',
    SET_UP: '设置',
    SET_UP_SUCCESSFULLY: '设置成功',
    SETUP_FAILED: '设置失败',
    SEX_FAREWELL: '性　　别',
    SHOP: '店铺',
    SHOP_ACCESSORIES: '店铺附件',
    SHOP_ADRESS: '店铺地址',
    SHOP_AREA: '店铺面积',
    SHOP_ENGLISH_NAME: '店铺英文名称',
    SHOP_EQUIPMENT: '店铺设备',
    SHOP_FAX: '店铺传真',
    SHOP_ID: '店铺Id',
    SHOP_INSPECTION: '巡店检查',
    m_info_common_000008: '巡店检查',
    SHOP_INSPECTION_DATA_IMPORT: '巡店检查数据导入',
    SHOP_INSPECTION_MODULE_CONFIGURATION: '巡店模块配置',
    SHOP_INSPECTION_PROBLEM_CATEGORIES: '巡店问题类别',
    SHOP_INSPECTION_REPORT: '巡店检查报告',
    SHOP_INSPECTION_TEMPLATE: '巡店检查模板',
    SHOP_INSPECTOR: '巡店人',
    SHOP_LABEL: '店铺标签',
    SHOP_MAILBOX: '店铺邮箱',
    SHOP_MAINTENANCE: '店铺维护',
    SHOP_NUMBER: '店铺编号',
    SHOP_PROPS_IMPORT: '店铺道具导入',
    SHOP_REPAIR: '店铺报修',
    m_info_common_000026: '店铺报修',
    SHOP_REPAIR_EMAIL: '店铺报修邮件',
    SHOP_REPAIR1: '店铺维修',
    SHOP_STAFF: '店铺员工',
    infoapi_common_000027: '店铺员工',
    SHOP_TOUR_PLAN: '巡店计划',
    m_info_common_000030: '巡店计划',
    SHOP_TOUR_PREVIEW: '巡店预览',
    SHOP_TOUR_REPORT: '巡店报告',
    SHOP_TOUR_TEMPLATE: '巡店模板',
    m_info_common_000003: '巡店模板',
    SHOP_TYPE: '店铺类型',
    SHOP_VISIT_ENTRY: '巡店条目',
    SHOPPING_MALL_APPLICATION_REQUIREMENTS: '商场办证要求',
    SHORT_NAME: '简称',
    SHOW_DEPRECATED: '显示弃用',
    SHOW_REPAIR_COSTS: '显示维修成本',
    SHOW_SCORE_IN_PDF: '在PDF中显示得分',
    SHOW_SUBORDINATES: '显示下级组织人员',
    SHUT_DOWN: '关闭',
    SIGNATURE: '签名',
    SIGNING_TIME: '签署时间',
    SIMPLIFIED_CHINESE: '简体中文',
    SINGLE_FILE_SIZE_EXCEEDS: '单个文件大小超出',
    SIZE: '尺寸',
    SMALL_CLASS_DOES_NOT_EXIST: '小类不存在;',
    SMS_NOTIFICATION: '短信通知',
    SMS_VERIFICATION: '登录短信验证',
    SORRY_SOMETHING_WENT_WRONG: '抱歉,出现异常：',
    SORRY_THE_DEALER_HAS_BEEN_USED_IN_BUSINESS_DATA_AND_CANNOT_BE_DELETED: '对不起，经销商已在业务数据中被使用不能被删除',
    SORRY_THE_PROGRAM_DOES_NOT_ALLOW_FILE_DOMAINS_WITH_THE_SAME_NAME_ATTRIBUTE: '对不起,程序不允许使用相同name属性的文件域!',
    SORRY_YOU_ARE_NOT_A_SYSTEM_ADMINISTRATOR_PLEASE_CONTACT_YOUR_SYSTEM_ADMINISTRATOR: '抱歉，您不是系统管理员，请与系统管理员联系。',
    SORRY_YOUR_PASSWORD_IS_WRONG_PLEASE_REENTER: '抱歉，您的密码错误，请重新输入',
    SORRY_YOUR_SOFTWARE_LICENSE_HAS_EXPIRED_PLEASE_CONTACT_R__SYSTEM_ADMINISTRATOR: '抱歉，您的软件授权已经过期，请联系R+系统管理员',
    SORRY_YOUR_USER_ACCOUNT_IS_LOCKED: '抱歉，您的用户帐号已被锁定',
    SORT: '排序',
    SORT_FIELDS: '排序字段',
    SPECIAL_CHARACTERS_ARE_NOT_ALLOWED: '不允许使用特殊字符',
    SPECIAL_TASK_TEMPLATE: '特殊任务模板',
    SPECIFICATION: '规格',
    STAFF_APPOINTMENT_DATA_TEMPLATE: '人员任职数据模板',
    STAFF_ASSESSMENT_TEMPLATE: '人员考核模板',
    STAFF_MANAGEMENT: '员工管理',
    STANDARD_CURRENCY: '本位货币',
    STANDARD_CURRENCY_CANNOT_BE_EMPTY: '本位货币不能为空',
    STANDARD_MODE: '标准模式',
    STAR_BRAND: '*所属品牌',
    STAR_DEFAULT_CURRENCY: '*默认货币',
    STAR_SHOP_LANGUAGE: '*店铺语言',
    STARSTORE_NAME: '*店铺名称',
    START_DATE: '开始日期',
    STARTING_TIME: '开始时间',
    STARTUP_PAGE_DIAGRAM: '启动页面图',
    STATISTIC_TYPE: '统计类型',
    STATISTICAL_DATE: '统计日期',
    STATUS: '状态',
    ExcelTemplate_common_000012: '状态',
    STATUS_QUERY: '状态查询',
    STICKY: '置顶',
    STICKY_COURSE: '置顶课程',
    STOCK_TRACKING_DATA_TEMPLATE: '货品追踪数据模板',
    STORE_AGENT: '店铺代派工',
    STORE_AREA_INPUT_VALUE_IS_INCORRECT: '店铺面积输入值有误;',
    STORE_ASSETS: '店铺资产',
    STORE_CATEGORIES_IN_USE_CANNOT_BE_DELETED: '正在使用的店铺类别，不能删除！',
    STORE_CATEGORY: '店铺类别',
    STORE_CATEGORY1: '店铺分类',
    STORE_CODE_CANNOT_BE_EMPTY: '店铺编码不能为空',
    STORE_CONTACT: '店铺联系人',
    STORE_DATA_IMPORT: '店铺数据导入',
    STORE_DATA_TEMPLATE: '店铺数据模板',
    STORE_DOCUMENT: '店铺文档',
    STORE_EQUIPMENT_DATA_TEMPLATE: '店铺设备数据模板',
    STORE_FIELD_CONFIGURATION: '店铺字段配置',
    STORE_ID: '店铺ID',
    STORE_INFORMATION: '店铺信息',
    STORE_INSPECTION_REPORT_EDIT: '巡店报告再编辑',
    STORE_LONGITUDE_INPUT_IS_WRONG: '店铺经度输入值有误;',
    STORE_MANAGEMENT: '店铺管理',
    STORE_MONITORING: '店铺监控',
    STORE_MONITORING_LIST: '店铺监控清单',
    STORE_NAME: '店铺名称',
    STORE_NAME_ALREADY_EXISTS: '店铺名称已存在;',
    STORE_NAME_CANNOT_BE_EMPTY: '店铺名称不可为空',
    STORE_PHONE: '店铺电话',
    STORE_POSTCODE_ENTERED_INCORRECT_VALUE: '店铺邮编输入值不正确;',
    STORE_REPAIR_CODE_MANAGEMENT: '店铺报修码管理',
    STORE_REPAIR_SPECIALIST_WILL_BE_GENERATED_LATER: '店铺报修专员将在稍后生成',
    STORE_STOREID_DOES_NOT_BELONG_TO_THE_BUSINESS: '店铺StoreID不属于该企业;',
    STORE_TYPE_DETAILS: '店铺类型详情',
    STORE_TYPE_INFORMATION: '店铺类型信息',
    STORE_TYPE_NAME: '店铺类型名称',
    STORE_TYPE_NUMBER: '店铺类型编号',
    STORES_CANNOT_ADD_SUBORDINATE_ORGANIZATIONS: '店铺不可以添加下级组织',
    STRING: '字符串',
    STUDYTIME: '学习时间',
    SUB_ACCOUNT: '子账号',
    SUBHEADINGS: '上级分类',
    SUBMIT_CONTENT: '提交内容',
    SUBORDINATE_POSITIONS: '下级职位',
    SUBSTANDARD_SCORE: '未达标得分',
    SUCCESS: '成功',
    SUCCESSFUL_OPERATION: '操作成功',
    SUCCESSFUL_OPERATION1: '操作成功！',
    SUCCESSFUL_RECOVERY: '恢复成功',
    SUCCESSFUL_SYNCHRONIZATION: '同步成功！',
    SUCCESSFULLY_DELETED: '删除成功！',
    SUCCESSFULLY_DELETED_JOB: '删除职位成功',
    SUCCESSFULLY_DELETED1: '成功删除',
    SUCCESSFULLY_DELETED2: '删除成功',
    SUCCESSFULLY_MODIFIED: '修改成功',
    SUCCESSFULLY_MODIFIED1: '修改成功！',
    SUIJIE_TECHNOLOGY: '【瑞界科技】',
    SUNDAY: '周日',
    SUPERIOR: '上级',
    SUPERIOR_AREA: '上级地区',
    SUPERIOR_SELECTION: '上级选择',
    SUPPLIER_ALIAS: '供应商别称',
    z_info_common_000005: '供应商别称',
    SUPPLIER_CLASSIFICATION: '供应商分类',
    SUPPLIER_CONTACT_INFORMATION: '供应商联系人信息',
    SUPPLIER_DATA_IMPORT: '供应商数据导入',
    SUPPLIER_DATA_TEMPLATE: '供应商数据模板',
    SUPPLIER_INFORMATION: '供应商信息',
    SUPPLIER_MANAGEMENT: '供应商管理',
    SUPPLIER_NAME: '供应商名称',
    SUPPLIER_NAME1: '供应商名称：',
    SUPPORTS_DOWNLOADING_UP_TO_50_DOCUMENTS_AT_THE_SAME_TIME: '最多支持同时下载50份文档',
    SURNAME: '姓',
    SWITCH_LANGUAGE: '切换语言',
    SYNC_FAILED: '同步失败！',
    SYNCHRONIZED_EASY_TO_UNDERSTAND_DATA: '同步易知数据',
    SYSTEM_HINT: '系统提示',
    SYSTEM_NAME: '信息管理平台',
    HOME_PAGE: '首页',
    SELECT_EXPORT_FIELD: '选择导出字段',
    SELECT_VIEW: '导出查看',
    EXPORT_FOLLOW_UP: '导出跟进',
    CURRENT_SELECT_FIELD: '当前选定的字段',
    PARENT_ORGANIZATION_NAME: '上级组织名称',
    WHETHER_ALLOW_MULTIPLE_PEOPLE: '是否允许多人',
    HAVE_A_JOB: '有无任职',
    EXPORT_SUCCESSFULLY: '导出成功',
    SYSTEM_NOTIFICATION: '系统通知',
    SYSTEM_REMINDER: '系统提醒',
    TAG_ID: '标签Id',
    TASK_TYPE: '任务类型',
    TASK_TYPE_EDIT: '任务类型编辑',
    TEMPLATE_ALREADY_EXISTS: '模板已存在;',
    TEMPLATE_DATA_IMPORT: '模板数据导入',
    TEMPLATE_DOES_NOT_EXIST: '模板不存在;',
    TEMPLATE_EDITING: '模板编辑',
    TEMPLATE_NAME: '模板名称',
    TEMPLATE_NAME_CANNOT_BE_EMPTY: '模板名称不能为空;',
    TEMPLATE_NUMBER: '模板序号',
    TEMPLATE_SETTINGS: '模板设置',
    TEMPLATE_TYPE: '模板类型',
    TEST_PAPER_DESCRIPTION: '试卷描述',
    TEST_PAPER_INFORMATION: '试卷信息',
    TEST_PAPER_LIST: '试卷列表',
    TEST_PAPER_NAME: '试卷名称',
    TEST_PAPER_NUMBER: '试卷编号',
    TEST_PAPER_NUMBER1: '试卷序号',
    TEST_PAPER_REMINDER: '试卷提醒',
    TEST_PAPER_TYPE: '试卷类型',
    TEST_SCORE: '考试得分',
    TEXT: '文本型',
    TEXT_CONTENT_CANNOT_BE_EMPTY: '文本内容不能为空',
    THE_ACCOUNT_DOES_NOT_EXIST: '不存在该账号',
    THE_AREA_NAME_DOES_NOT_EXIST: '该地区名称不存在;',
    THE_BASIC_DATA_IS_INCOMPLETE_PLEASE_MAINTAIN_THE_STORE_CATEGORY: '基础数据不完整，请维护店铺类别。',
    THE_BASIC_DATA_IS_INCOMPLETE_PLEASE_MAINTAIN_THE_STORE_TYPE: '基础数据不完整，请维护店铺类型。',
    THE_BRAND_NAME_DOES_NOT_EXIST: '该品牌名称不存在;',
    THE_CLASSIFICATION_OF_THE_TRANSFER_IN_USE_CANNOT_BE_DELETED: '正在使用的交接本分类，不能删除！',
    THE_COMPANY_CAN_ADD_PEOPLE_FULL: '该公司可添加人员已满',
    THE_COMPANY_HAS_INSUFFICIENT_REMAINING_ADDABLE_STORES: '该公司剩余可添加店铺数量不足',
    THE_COMPANY_HAS_INSUFFICIENT_REMAINING_PERSONNEL_TO_ADD: '该公司剩余可添加人员数量不足',
    THE_CORRESPONDING_DEVICE_CODE_ALREADY_EXISTS_UNDER_THE_DEVICE_TYPE: '设备类型下已存在对应的设备码;',
    THE_COURSEWARE_YOU_UPLOADED_IS_NOT_A_STANDARD_FORMAT: '你上传的课件不是标准格式',
    THE_CUSTOMER_DOES_NOT_EXIST: '该客户不存在;',
    THE_DATA_IS_INCORRECT_PLEASE_VERIFY: '数据有误，请校验。',
    THE_DATA_IS_NOT_IMPORTED_PLEASE_WAIT: '数据未导入完成，请等待！',
    THE_DATA_IS_WRONG: '数据有误!',
    THE_DATA_IS_WRONG_DO_YOU_WANT_TO_DOWNLOAD_AND_VIEW_THE_PROMPT_FILE: '数据有误，是否下载查看提示文件？',
    THE_DEALER_CATEGORY_BEING_USED_CANNOT_BE_DELETED: '正在使用的经销商分类，不能删除！',
    THE_DEALER_NAME_DOES_NOT_EXIST: '该经销商名称不存在;',
    THE_DEVICE_NAME_DOES_NOT_HAVE_A_CORRESPONDING_DEVICE_CODE: '该设备名称无对应的设备码;',
    THE_DEVICE_TYPE_AND_THE_CORRESPONDING_DEVICE_CODE_ALREADY_EXIST: '该设备类型下以及对应的设备码已存在！',
    THE_DIRECTORY_NAME_IS_INCORRECT: '目录名不正确。',
    THE_DOCUMENT_CLASSIFICATION_IN_USE_CANNOT_BE_DELETED: '正在使用的文档分类，不能删除！',
    THE_ENGLISH_NAME_OF_THE_ITEM_UNDER_THE_SAME_ITEM_CATEGORY_CANNOT_BE_REPEATED: '同一道具分类下道具英文名称不能重复;',
    THE_ENTRY_NAME_ALREADY_EXISTS_UNDER_THE_SAME_TEMPLATE_CATEGORY: '同一模板分类下条目名称已存在;',
    THE_ENTRY_NUMBER_ALREADY_EXISTS_UNDER_THE_SAME_TEMPLATE_CATEGORY: '同一模板分类下条目序号已存在;',
    THE_FILE_ID_YOU_WANT_TO_MODIFY_IS_WRONG_PLEASE_TRY_AGAIN_LATER: '您要修改的文件Id有误，请稍后再试',
    THE_FILE_TYPE_YOU_ARE_TRYING_TO_MODIFY_IS_INCORRECT_PLEASE_TRY_AGAIN_LATER: '您要修改的文件类型有误，请稍后再试',
    THE_INPUT_VALUE_IS_NOT_IN_THE_VALID_RANGE: '输入值不在有效范围内;',
    THE_LEVEL_DOES_NOT_MATCH_THE_SUPERIOR_LEVEL: '层级与上级层级不匹配;',
    THE_MAINTENANCE_CODE_IS_BEING_GENERATED_PLEASE_REFRESH_THE_PAGE_LATER_TO_VIEW: '维修码生成中，请稍后刷新页面查看。',
    THE_MANUAL_NAME_ALREADY_EXISTS: '手册名称已存在;',
    THE_MAXIMUM_LENGTH_MUST_BE_GREATER_THAN_0: '最大长度必须大于0！',
    THE_NAME_CANNOT_BE_REPEATED_UNDER_THE_SAME_LEVEL: '同上级下名称不能重复;',
    THE_NAME_OF_THE_PARENT_ORGANIZATION_CANNOT_BE_EMPTY: '上级组织名称不能为空;',
    THE_NAME_OF_THE_SAME_CLASS_CANNOT_BE_THE_SAME: '同一级分类名称不能相同;',
    THE_NAME_OF_THE_SUPERIOR_AREA_DOES_NOT_EXIST: '该上级地区名称不存在;',
    THE_NAMES_OF_MAINTENANCE_FAULTS_UNDER_THE_SAME_MAINTENANCE_FAULT_CLASSIFICATION_ARE_NOT_ALLOWED_TO_BE_DUPLICATED: '同一维修故障分类下的维修故障名称不允许重复;',
    THE_NAMES_OF_PASSENGER_FLOW_CHANNELS_UNDER_THE_SAME_STORE_ORGANIZATION_CANNOT_BE_DUPLICATED: '同一店铺组织下客流通道名称不能重复;',
    THE_NUMBER_OF_STORE_FLOOR_PLANS_HAS_REACHED_THE_UPPER_LIMIT_AND_A_MAXIMUM_OF_TEN_STORE_FLOOR_PLANS_CAN_BE_UPLOADED: '店铺平面图数量已达上限,最多可以上传十张店铺平面图。',
    THE_ORGANIZATION_DOES_NOT_EXIST: '该组织不存在;',
    THE_ORGANIZATION_NAME_DOES_NOT_EXIST: '该组织名称不存在;',
    THE_OTHER_PARTY_HAS_BEEN_DELETED: '对方已删除',
    THE_OTHER_PARTY_IS_FROZEN: '对方已冻结',
    THE_PARENT_ORGANIZATION_CANNOT_BE_THE_CURRENT_ORGANIZATION: '上级组织不能是当前组织',
    THE_PASSWORD_YOU_SET_IS_A_SECURITY_RISK_PLEASE_RESET_IT: '您设置的密码存在安全风险，请重新设置',
    THE_PHONE_NUMBER_IS_INCORRECT: '手机号码不正确！',
    THE_PHONE_NUMBER_USER_ALREADY_EXISTS: '该手机号用户已存在;',
    THE_PRODUCT_NAME_DOES_NOT_EXIST: '商品名称不存在;',
    THE_ROLE_DOES_NOT_ALLOW_MULTIPLE_PEOPLE_TO_TAKE_OFFICE: '该角色不允许多人就职;',
    THE_ROLE_DOES_NOT_EXIST: '该角色不存在;',
    THE_ROLE_DOES_NOT_EXIST_UNDER_THE_ORGANIZATION: '该组织下不存在该角色;',
    THE_ROLE_NAME_ALREADY_EXISTS: '该角色名称已存在',
    THE_ROLE_NAME_ALREADY_EXISTS1: '已存在该角色名称;',
    THE_ROLE_OF_SETTING: '角色设定',
    THE_SAME_ENTRY_NAME_OR_SERIAL_NUMBER_EXISTS_IN_THE_SAME_TEMPLATE_CATEGORY: '同一模板分类下存在相同的条目名称或序号',
    THE_SERIAL_NUMBER_CAN_ONLY_BE_NUMERIC_OR_EMPTY: '序号只能为数字或空',
    THE_SHOP_DOES_NOT_EXIST: '该店铺不存在;',
    THE_SHOP_DOES_NOT_EXIST1: '不存在该店铺;',
    THE_SHOP_NUMBER_ALREADY_EXISTS: '该店铺编号已存在;',
    THE_SHOP_TYPE_DOES_NOT_EXIST: '不存在该店铺类型;',
    THE_SINGULAR_THE_NUMBER_OF_PRODUCTS_AND_THE_TOTAL_SALES_CANNOT_BE_EMPTY_AT_THE_SAME_TIME: '单数，产品数，销售总额不能同时为空;',
    THE_SIZE_OF_YOUR_UPLOADED_IMAGE_IS: '您上传的图片尺寸为',
    THE_START_TIME_CANNOT_BE_LESS_THAN_THE_FILING_DATE: '开始时间不可小于归档日期;',
    THE_STATISTICAL_DATE_CANNOT_BE_GREATER_THAN_THE_CURRENT_DATE: '统计日期不可大于当前日期;',
    THE_STATISTICAL_DATE_CANNOT_BE_LESS_THAN_THE_FILING_DATE: '统计日期不可小于归档日期;',
    THE_STOCK_QUANTITY_CANNOT_BE_EMPTY: '入库数量不能为空',
    THE_STORE_DIMENSION_INPUT_VALUE_IS_INCORRECT: '店铺维度输入值有误;',
    THE_STORE_DOES_NOT_EXIST: '店铺不存在;',
    THE_STORE_LANGUAGE_TYPE_DOES_NOT_EXIST: '店铺语言类型不存在;',
    THE_STORE_MAILBOX_INPUT_VALUE_IS_INCORRECT: '店铺邮箱输入值不正确;',
    THE_SUPERIOR_CLASSIFICATION_DOES_NOT_EXIST: '上级分类不存在;',
    THE_SUPPLIER_CATEGORY_BEING_USED_CANNOT_BE_DELETED: '正在使用的供应商分类，不能删除！',
    THE_SUPPLIER_DOES_NOT_EXIST: '该供应商不存在;',
    THE_TOTAL_NUMBER_OF_DAYS_FOR_THE_TEMPLATE_STORE_MUST_BE_GREATER_THAN_0: '模板带店总天数必须大于0',
    THE_TOTAL_NUMBER_OF_DAYS_IN_THE_TEMPLATE_STORE_MUST_BE_A_NUMERIC_TYPE: '模板带店总天数必须为数字类型',
    THE_TRACKING_NUMBER_OF_THE_ITEM_ALREADY_EXISTS: '已经存在该货品追踪编号;',
    THE_UPLOAD_DIRECTORY_DOES_NOT_EXIST: '上传目录不存在。',
    THE_UPLOAD_DIRECTORY_DOES_NOT_HAVE_WRITE_PERMISSION: '上传目录没有写权限。',
    THE_UPLOAD_FILE_SIZE_EXCEEDS_THE_LIMIT: '上传文件大小超过限制。',
    THE_UPPER_CLASSIFICATION_HAS_DUPLICATE_DATA: '上级分类有重复数据;',
    THE_USER_ALREADY_HAS_THE_POSITION: '该用户已存在该职位;',
    THE_USER_ENTERED_THE_MAILBOX_INCORRECTLY: '用户绑定邮箱输入值不正确;',
    THE_USERS_WORK_MAILBOX_INPUT_VALUE_IS_INCORRECT: '用户工作邮箱输入值不正确;',
    THE_VALUE_ENTERED_ON_THE_SHOP_OPENING_DATE_IS_INCORRECT: '开店日期输入值有误;',
    THE_VALUE_OF_THE_LAST_RENOVATION_DATE_IS_INCORRECT: '最近装修日期输入值有误;',
    THE_WORD_COUNT_EXCEEDS_200_WORDS: '字数超过200字;',
    THE_WRONG_ITEM_CLASSIFICATION_LEVEL_IS_SELECTED: '选择的道具分类层级有误',
    THE_YEAR_OF_BIRTH_CANNOT_EXCEED_THE_CURRENT_YEAR: '出生年份不能超过当前年份;',
    THERE_ARE_NO_COMMODITIES_UNDER_THE_CATEGORY: '大类下没有商品;',
    THERE_IS_DUPLICATE_DATA_IN_EXCEL: 'Excel中有重复数据;',
    THERE_IS_NO_SUCH_CHANNEL_NUMBER_UNDER_THE_STORE: '该店铺下没有该通道编号;',
    THERE_IS_NO_SUCH_SUBCATEGORY_UNDER_THE_BIG_CATEGORY: '大类下没有该小类;',
    THIS_ALREADY_EXISTS_IN_EXCEL: 'Excel中已经存在该',
    THIS_BRAND_HAS_BEEN_ASSIGNED_A_STORE_AND_CANNOT_BE_DELETED: '该品牌已分配店铺,不能删除',
    THIS_FUNCTION_DOES_NOT_SUPPORT_FOLDERS: '该功能不支持文件夹',
    THIS_FUNCTION_IS_ONLY_SUPPORTED_FOR_THE_SUPPLIER_WHOSE_SERVICE_TYPE_IS_SHOP_REPAIR: '该功能暂时仅支持服务类型为“店铺维修”的供应商',
    THIS_ITEM_CANNOT_ADD_ORGANIZATION: '该项不可添加组织',
    THIS_POSITION_DOES_NOT_EXIST: '该职位不存在;',
    THIS_PRODUCT_IS_USED_AND_CANNOT_BE_DELETED: '该商品有人使用,不能删除',
    THIS_USER_DOES_NOT_EXIST: '该用户不存在;',
    THRESHOLD: '阈值',
    THRESHOLD_MODE: '阈值模式',
    THRESHOLD1: '阈　　值',
    THURSDAY: '周四',
    TICKETS: '客单数',
    TIME: '时间',
    TITLE: '标题',
    TITLE_CONTENT: '题目内容',
    TITLE_DESCRIPTION: '题目描述',
    TITLE_DETAILS: '题目详情',
    TITLE_PICTURE: '题目图片',
    TITLE1: '题目名称',
    TO: '到',
    TO1: '至',
    TOTAL_NUMBER_OF_DAYS_WITH_TEMPLATE_SHOP: '模板带店总天数',
    TOTAL_NUMBER_OF_MATTERS: '事项总数',
    TOTAL_NUMBER_OF_STAGES: '阶段总数',
    TOTAL_PASSENGER_FLOW: '客流总量',
    TOTAL_SALES: '销售总额',
    TOTAL_SALES_AMOUNT: '销售总金额',
    TOTAL_SCORE_IS_SHOWN_AS: '总分显示为',
    TOTAL_TRANSACTION: '交易总额',
    TOTAL_TRANSACTIONS: '交易总量',
    TRADITIONAL_CHINESE: '繁体中文',
    TRADITIONAL_CHINESE1: '中文繁体',
    TRANSFER_RECORD_CATEGORY: '交接记录类别',
    TRANSFER_THIS_CATEGORY: '交接本分类',
    TREE_MENU_BASIC_DATA: '基础数据',
    TURN_ON: '打开',
    TURN_ON_THE_WATERMARK_ON_THE_SCREEN_OF_THE_MOBILE_PHONE: '开启手机端屏幕水印',
    TURN_ON_TOP_SORT: '开启置顶排序',
    TURNOVER: '成交金额',
    TYPE_CONVERSION_FAILED_TYPE_CANNOT_BE_CONVERTED: '类型转换失败,无法转换类型:',
    TYPE_ENCODING: '类型编码',
    TYPE_ENGLISH_NAME: '类型英文名称',
    TYPE_ID: '类型ID',
    TYPE_INFORMATION: '类型信息',
    TYPE_NAME: '类型名称',
    TYPE_NUMBER: '类型编号',
    TYPE_OPERATION: '类型操作',
    TYPES_OF: '类型',
    UNFREEZE: '解除冻结',
    UNIT: '单位',
    UNIT_PRICE: '单价',
    UNKNOWN_MISTAKE: '未知错误',
    UNKNOWN_MISTAKE1: '未知错误。',
    UNLIMITED: '不限',
    UNLIMITED_CATEGORIES: '不限类别',
    UNLIMITED_ORGANIZATION: '不限组织',
    UNLOCKED: '未锁定',
    UNPIN: '取消置顶',
    UNQUALIFIED_SCORE: '不合格得分',
    UNSPECIFIED: '未指定',
    UNSUCCESSFUL: '不成功',
    UNSUCCESSFUL_DATA: '未成功数据',
    UPDATE_COMPLETED: '更新成功！',
    UPDATE_COMPLETED1: '更新成功',
    UPDATE_DATA: '更新数据',
    UPDATE_FAILED: '更新失败:',
    UPDATE_FAILED1: '更新失败',
    UPDATE_FAILED2: '更新失败！',
    UPDATE_MULTILINGUAL: '更新多语言',
    UPLOAD: '上传',
    UPLOAD_ATTACHMENT: '上传附件',
    UPLOAD_DATE: '上传日期',
    UPLOAD_FAILED: '上传失败',
    UPLOAD_FAILED1: '上传失败:',
    UPLOAD_FAILED2: '上传失败。',
    UPLOAD_FILE_NOT_FOUND: '未找到上传文件',
    UPLOAD_FILES: '上传文件',
    UPLOAD_IMAGE: '上传图片',
    UPLOAD_INFORMATION: '上传资料',
    UPLOAD_LIMIT: '的上传限制!',
    UPLOAD_OF_STORE_ATTACHMENT_FAILED: '上传店铺附件失败',
    UPLOAD_SHOP_ATTACHMENT: '上传店铺附件',
    UPLOAD_TIME: '上传时间',
    UPLOAD_TRAINING_MATERIALS: '上传培训资料',
    UPLOADED_BY: '上传者',
    UPLOADED_DATA_EXCEEDS: '上传数据超过',
    UPLOADED_SUCCESSFULLY: '上传成功',
    UPLOADING_TRAINING_MATERIALS_FAILED: '上传培训资料失败',
    USE_DETAILS: '使用详情',
    USER: '用户',
    USER_AGREEMENT: '用户协议',
    USER_AGREEMENT_UPLOAD: '用户协议上传',
    USER_CANCELED_OPERATION: '用户取消操作',
    USER_DATA_IMPORT: '用户数据导入',
    USER_ID: '用户Id',
    USER_JOB_INFORMATION_IMPORT: '用户任职信息导入',
    USER_REFERENCE: '用户参照',
    USER_REFERENCE_IN_USE_CANNOT_BE_DELETED: '正在使用的用户参照，不能删除！',
    USER_TYPE: '用户类型',
    ExcelTemplate_common_000013: '用户类型',
    USERNAME: '用户名',
    USERS_IN_EXCEL_CANNOT_REPEAT_THE_SAME_POSITION: 'Excel中用户不可重复任职同一职位;',
    VALID_UNTIL: '有效期至',
    VALUE: '数值',
    VALUE_ELEMENT: '值元素',
    VENDOR_TYPE_NAME: '供应商类型名称',
    VENDOR_TYPE_NUMBER: '供应商类型编号',
    VERIFICATION_CODE: '验证码',
    VIEW: '查看',
    VIEW_REPAIR_CODE: '查看报修码',
    VIEW_SERVICE_CODE: '查看服务代码',
    VISUAL_DISPLAY: '视觉陈列',
    m_info_common_000020: '视觉陈列',
    VISUAL_DISPLAY_RECORD: '视觉陈列记录',
    VOIP_CALL_HISTORY: 'Voip通话记录',
    WAREHOUSE: '入库',
    WAREHOUSE_IN_THIS_ISSUE: '本期入库',
    WEATHER_CODE: '天气代码',
    WEEK: '周',
    WEIGHTS: '权重',
    WEIGHTS1: '权　　重',
    WELCOME_STRING: '您好',
    WELCOME_STRING1: '您已登录到',
    WHETHER_ADMINISTRATOR: '是否管理员',
    WHETHER_COMPLETED: '是否完成',
    WHETHER_GIVEAWAY: '是否赠品',
    WHETHER_LOCKED: '是否锁定',
    WHETHER_LOGIN_PROTECTION: '是否登录保护',
    WHETHER_PROJECT_MANAGER: '是否工程管理员',
    WHETHER_SUCCEED: '是否成功',
    WHETHER_THE_PROBLEM_DESCRIPTION_IS_REQUIRED: '问题描述是否必填',
    WHETHER_THE_SUPPLIER_INSTALLS: '是否供应商安装',
    WHETHER_TO_CONFIRM_THE_REPAIR_CODE: '是否确认恢复报修码',
    WHETHER_TO_CONNECT: '是否接通',
    WHETHER_TO_ENABLE: '是否启用',
    WHETHER_TO_MODIFY_THE_SCORE_MUST_NOT_BE_EMPTY: '是否允许修改得分不得为空;',
    WHETHER_TO_SELL: '是否销售',
    WHETHER_TO_STICK: '是否置顶',
    WITHOUT_THE_MANUAL_ID: '没有该手册id;',
    WITHOUT_THE_PRIMARY_KEY_ID: '没有该主键id;',
    WORK_EMAIL: '工作邮箱',
    WORK_INFO: '工作信息',
    WORK_SHOP_WITH_SHOP_TEMPLATE: '职店带店模板',
    WORKING_ADDRESS: '工作地址',
    WORKING_AGE: '工龄',
    WRONG_BIRTHDAY_FORMAT: '出生日格式有误;',
    YEAR: '年',
    YEAR_OF_BIRTH: '出生年份',
    YES: '是',
    YOU_ARE_NOT_USING_IE8_OR_ABOVE_IT_MAY_CAUSE_COMPATIBILITY_PROBLEMS_AND_PREVENT_YOU_FROM_USING_IT_NORMALLY: '您正在使用的不是IE8及以上版本，有可能会产生兼容性问题，导致您无法正常使用。',
    YOU_HAVE_NOT_SELECTED_A_NODE: '您还没有选择节点',
    YOU_HAVE_NOT_SELECTED_THE_PARENT_FOLDER: '您还没有选择上级文件夹',
    APPLY_FOR_REPAIRS: '报修申请提交图片配置',
    MUSTPROPACCEPTANCESCORE: '道具验收打分是否必填',
    MUSTPROPCONTENT: '道具问题描述是否必填',
    PROPACCEPTANCEIMGCOUNT: '道具验收图片配置',
    PROPS_MODULE_CONFIGURATION: '道具模块配置',
    HISTORICAL_RATE: '历史汇率',
    ADD_FAILED_THE_FORM_NAME_ALREADY_EXISTS: '添加失败,该表单名称已经存在',
    ADD_FORM: '添加表单',
    BOOLEAN: '布尔型',
    CALCULATION_FORMULA: '计算公式',
    CATEGORY_DEFAULT_VENDOR_INVALID: '你修改的类别限制导致以下分类的默认供应商无效, 请手动设置.',
    CHECKBOX: '复选框',
    COMPANY: '公司',
    CONTROL_DESCRIPTION: '控件说明',
    CONTROL_DESCRIPTION1: '控件描述',
    CONTROL_NAME: '控件名称',
    CONTROL_TYPE: '控件类型',
    COUNTRY_NUMBER: '国 别 号',
    CURRENT_EXCHANGE_RATE: '当前汇率',
    CUSTOM_REFERENCE: '自定义参照',
    DATA_IMPORT: '数据导入',
    DATE_CONTROL: '日期控件',
    DATE_TYPE: '日期型',
    DECIMAL_PLACES1: '小数位数',
    DEFAULTS: '默认值',
    DELETE_FORM: '删除表单',
    DROP_DOWN_BOX: '下拉框',
    ENUMERATION: '枚举型',
    FILE_UPLOAD_CONTROL: '文件上传控件',
    FORM_DESCRIPTION: '表单描述',
    FORM_DETAILS: '表单明细',
    FORM_NAME: '表单名称',
    FORM_NAME_CONTAINS_ILLEGAL_CHARACTERS_ONLY_ALPHANUMERIC_AND_UNDERSCORES_ARE_ALLOWED: '表单名称包含非法字符，只允许字母数字和下划线！',
    FORM_TITLE: '表单标题',
    IF_YOU_DELETE_THE_TEMPLATE_ALL_THE_QUESTIONS_IN_THE_TEMPLATE_WILL_BE_DELETED_TOGETHER_ARE_YOU_SURE_YOU_WANT_TO_DELETE_IT: '如果删除模板，模板内的所有问题将被一起删除, 您确认删除吗？',
    IMPORT_FORM: '导入表单',
    INPUT_CHARACTERS_DO_NOT_MEET_REQUIREMENTS: '输入字符不符合要求',
    IS_EMPTY: '是否为空',
    MAX: '最大值',
    MINIMUM_VALUE: '最小值',
    NO_PICTURE: '无图片',
    NOTE_CURRENTLY_ONLY_SUPPORTS_XLS_FORMAT: '注：当前仅支持.xls格式',
    OPTIONAL_ROLE: '可选角色',
    PICTURE_UPLOAD_CONTROL: '图片上传控件',
    PRIORITY_HIGHLIGHTING: '优先级高亮显示',
    PUBLISHED_SUCCESSFULLY: '发布成功',
    REFERENCE_TYPE: '参照类型',
    RELEASE: '发布',
    SELECTED_ROLES: '已选角色',
    SEQUENCE: '序列',
    STANDARD_MODE1: '标准模式(所有条目之和)',
    STORE_INFO: '店铺资料',
    SYSTEM_REFERENCE: '系统参照',
    TASK_CENTER: '任务中心',
    TEXT_BOX: '文本框',
    THE_MAXIMUM_AND_MINIMUM_RANGE_IS_2147483648_TO_2147483647: '最大最小值范围是-2147483648到2147483647',
    THE_MAXIMUM_LENGTH: '最大长度',
    THRESHOID_MODE1: '阈值模式(根据子项得分,判断大类是否达标)',
    TIME_CONTROL: '时间控件',
    TIME_TYPE: '时间型',
    TOUR_CATEGORY: '巡店类别',
    TYPE_OF_DATA: '数据类型',
    UPDATE_TIME: '更新时间',
    WHETHER_TO_ALLOW_NULL: '是否允许为空',
    WHETHER_TO_DISPLAY_THE_LIST: '是否列表显示',
    WHETHER_TO_SHOW: '是否显示',
    WORK_SHOP_WITH_SHOP: '职店带店',
    r_info_common_000022: '职店带店',
    d_info_common_000022: '职店带店',
    YZAPPID: 'YZAPPID',
    z_info_common_000001: '序号不可重复',
    z_info_common_000004: '必须填写完工结算',
    z_info_common_000009: '维修申请重新派工',
    z_info_common_000010: '验收催办',
    z_info_common_000011: '用户留言',
    z_info_common_000012: '维修订单取消',
    z_info_common_000013: '维修申请完成',
    z_info_common_000014: '派工（选择维修工）',
    z_info_common_000015: '维修申请待定',
    z_info_common_000016: '新增维修申请',
    z_info_common_000017: '一键催办',
    z_info_common_000018: '生成订单',
    z_info_common_000019: '维修方案拒绝',
    z_info_common_000020: '验收不通过',
    z_info_common_000021: '验收截止提醒',
    z_info_common_000022: '派工（录入信息）',
    z_info_common_000023: '维修方案提交',
    z_info_common_000024: '拒绝维修申请',
    z_info_common_000025: '派工截止提醒',
    z_info_common_000026: '返修邮件',
    z_info_common_000027: '取消维修申请单',
    z_info_common_000028: '退回',
    z_info_common_000029: '验收通过',
    z_info_common_000030: '订单完成',
    z_info_common_000031: '审核维修申请',
    z_info_common_000032: '维修方案确认',
    z_info_common_000033: '询价',
    z_info_common_000034: '提交完工结算',
    z_info_common_000035: '确认完工结算',
    z_info_common_000036: '拒绝完工结算',
    z_info_common_000037: '启用维修项目',
    z_info_common_000038: '未找到用户信息',
    z_info_common_000039: '该账号已删除，是否恢复之前的记录？',
    z_info_common_000040: '恢复账号',
    z_info_common_000041: '新建账号',
    z_info_common_000042: '请选择要恢复的账号',
    z_info_common_000043: '请选择要恢复的账号的职位',
    z_info_common_000044: '被删除的记录',
    z_info_common_000006: '店铺语言',
    z_info_common_000007: '默认货币',
    z_info_common_000008: 'GPS',
    USER_ADDED_SUCCESS_MESSAGE: '账号和初始密码已发送短信通知用户',
    z_info_common_000045: '道具管理配置',
    z_info_common_000046: '是否自动完成',
    z_info_common_000047: '自验收后',
    z_info_common_000048: '是否允许补发',
    z_info_common_000049: '天',
    z_info_common_000050: '摄像机信息',
    z_info_common_000051: '平台类型',
    z_info_common_000052: '访问类型',
    z_info_common_000053: '摄像机编号',
    z_info_common_000054: '设备序列号',
    z_info_common_000055: '区域',
    z_info_common_000056: '摄像机名称',
    z_info_common_000057: '摄像机链接',
    z_info_common_000058: '通道号',
    z_info_common_000059: '设备验证码',
    z_info_common_000060: '摄像机管理',
    z_info_common_000061: '同一摄像头不允许同一个店铺多次绑定',
    z_info_common_000062: '摄像头编号不允许重复',
    z_info_common_000063: 'Link播放模式下的摄像机直播链接地址，可以播放的摄像机地址',
    z_info_common_000064: '平台APPKey,申请可以参阅各官网平台',
    z_info_common_000065: '平台AppSecret,申请可以参阅各官网平台',
    z_info_common_000066: '设备机身上的设备序列号',
    z_info_common_000067: '设备验证码，设备机身上的六位大写字母',
    z_info_common_000068: '入职日期',
    z_info_common_000069: '闭店',
    z_info_common_000070: '邮箱不能重复，请重新填写',
    z_info_common_000072: '请先删除维修分类的绑定关系',
    z_info_common_000071: '请先删除维修故障的绑定关系',
    z_info_common_000073: '问题分类名称不能重复',
    z_info_common_000074: '显示职位',
    z_info_common_000075: '店铺代发货',
    z_info_common_000076: '国家/地区',
    z_info_common_000077: '闭店时间',
    z_info_common_000078: '入职日期格式有误;',
    z_info_common_000079: '闭店时间不能超过当前时间',
    z_info_common_000080: '组织类型不存在',
    z_info_common_000081: '申请撤回',
    z_info_common_000082: '允许申请无库存道具',
    z_info_common_000083: '目前仅支持公共文件，在线培训，角色的配置',
    z_info_common_000084: '只查看相同组织类型的角色',
    z_info_common_000085: '公共文件配置',
    z_info_common_000086: '闭店时间格式有误',
    z_info_common_000087: '正常',
    z_info_common_000088: '排序配置',
    'z_info_common_000089\t': '已发送，请稍候',
    z_info_common_000090: '批量停用',
    z_info_common_000091: '显示停用',
    z_info_common_000092: '是否确认停用？',
    PLEASE_ENTER_ACCOUNT: '请输入账号',
    ACCOUNT_PASSWORD_CANNOT_EMPTY: '抱歉，账号密码不能为空，请重新输入',
    InfoAccountCannotEmpty: '抱歉，账号不能为空，请重新输入',
    InfoPleaseSelectCompany: '请选择公司',
    InfoYourPasswordIsEmpty: '抱歉，您的密码为空，请重新输入',
    InfoLogOut: '退出登录',
    ImportOrExport: '导入/导出',
    SearchedOut: '已搜索出',
    Results: '个结果',
    Operation: '操作',
    Edit: '编辑',
    TurnIntoShop: '转为店铺',
    Filter: '过滤',
    PleaseEnter: '请输入',
    DeleteSelectOrganization: '是否删除选中的组织?',
    DeletionCancelled: '已取消删除',
    Return: '返回',
    SelectOrganization: '选择组织',
    NewOrganization: '新增组织',
    EditOrganization: '编辑组织',
    NoSelectMsg1: '不允许选择自己及自己以下的组织为上级组织',
    EditSuccess: '编辑成功!',
    InfoStoreStatus: '店铺状态',
    InfoIsDeleteStore: '是否删除选中的店铺?',
    InfoSelectTimeRange: '选择时间范围',
    InfoMustContain: '必须包含@符',
    InfoServerBusy: '服务器繁忙',
    InfoDataNoExist: '数据不存在',
    InfoNoLoginRights: '你没有登录权限，请联系管理员',
    InfoSubmitFailed: '提交失败',
    InfoCreationFailed: '创建失败',
    InfoUpdateFailed: '更新失败',
    InfoAgainLogin: '您的登录已失效，请重新登录',
    InfoInvalidEnterpriseWechatAuthcode: '企业微信AuthCode无效',
    InfoAccountNoExist: '账号不存在，请联系管理员',
    InfoCompanyDeleted: '公司已被删除，请联系R+管理员',
    InfoCompanyFrozen: '公司已被冻结，请联系R+管理员',
    InfoUserDeleted: '用户已被删除',
    InfoUserFrozen: '用户已被冻结',
    InfoNotSystemAdministrator: '抱歉，您不是系统管理员，请与管理员联系',
    InfoPasswordError: '抱歉，您的密码错误，请重新输入',
    InfoCompanyExpired: '公司已经过期',
    InfoNameAlreadyExists: '名字已存在',
    InfoOrganizationTypeNoExist: '组织类型不存在',
    InfoSuperiorOrganizationNoExist: '上级组织不存在',
    InfoStoreNoExist: '店铺不存在',
    InfoStoreOrganizationNoExist: '店铺组织不存在',
    InfoStoreCodeAlreadyExists: '店铺编号已存在',
    InfoStoreExistingPosition: '店铺存在任职',
    InfoOrganizationExistingPosition: '组织存在任职',
    InfoSubsetsOrganizations: '组织存在子集组织',
    InfoOrganizationTypeIsShop: '组织类型为店铺',
    InfoOrganizationTypeNotModified: '组织类型不允许修改',
    InfoWechatSynchronization: '微信同步的组织不允许删除',
    InfoUnauthorized: '未授权，请重新登录',
    InfoAccessDenied: '拒绝访问',
    InfoRequestError: '请求错误,未找到该资源',
    InfoRequestMethodNoAllowed: '请求方法未允许',
    InfoRequestTimeout: '请求超时',
    InfoServerSideError: '服务器端出错',
    InfoNetworkNoImplemented: '网络未实现',
    InfoNetworkError: '网络错误',
    InfoServiceNoAvailable: '服务不可用',
    InfoNetworkTimeout: '网络超时',
    InfoNoSupportedRequest: 'http版本不支持该请求',
    InfoServerResponseTimeout: '服务器响应超时，请刷新当前页',
    InfoConnectServerFailed: '连接服务器失败',
    z_info_common_000093: '店铺经度',
    z_info_common_000094: '店铺纬度',
    z_info_common_000095: '最近装修日期',
    z_info_common_000096: '店铺可以维修时间',
    z_info_common_000097: '营业时间(开店)',
    z_info_common_000098: '营业时间(关店)',
    z_info_common_000099: '平面图标题',
    z_info_common_000100: '平面图文件地址',
    z_info_common_000101: '店铺编号长度最大12个字符；',
    z_info_common_000102: '状态（正常：0，闭店：1）',
    z_info_common_000103: '状态只允许输入0或1',
    infoapi_common_000001: '中国',
    infoapi_common_000002: '美国或加拿大',
    infoapi_common_000003: '俄罗斯',
    infoapi_common_000004: '秘鲁',
    infoapi_common_000005: '巴西',
    infoapi_common_000006: '澳大利亚',
    infoapi_common_000007: '印尼',
    infoapi_common_000008: '菲律宾',
    infoapi_common_000009: '新西兰',
    infoapi_common_000010: '新加坡',
    infoapi_common_000011: '泰国',
    infoapi_common_000012: '日本',
    infoapi_common_000013: '韩国',
    infoapi_common_000014: '缅甸',
    infoapi_common_000015: '香港',
    infoapi_common_000016: '澳门',
    infoapi_common_000017: '台湾',
    RESETCancelled: '已取消重置',
    BATCH_SET: '批量操作',
    SET_LABEL: '设置标签',
    Note_WXSYNCHROHIZATION_LABEL: '注：*代表企业微信同步的标签',
    Note_COMMON_LABEL: '注：当前选中xxx家店铺，本页面仅显示和维护这些店铺的共有标签',
    NEW_LABEL: '新增标签',
    IS_RETURN_STORE: '是否确认将当前组织转成店铺',
    TurnIntoOrg: '转为组织',
    IS_RETURN_ORG: '是否确认将店铺还原为组织？',
    SUCCESSFULLY_REDUCTION: '还原成功',
    SUCCESSFULLY_TRANSFORMATION: '转换成功',
    Is_Enterprise_Micro_Synchronization: '是否企微同步',
    Latest_Login_Time: '最新登录时间',
    Position_Information: '职位信息',
    No_ADMINISTRATOR: '非管理员',
    Open: '开启',
    Not_Open: '未开启',
    Lock_In_People: '锁定人员',
    Unbundling: '解绑',
    Binding: '绑定中',
    Retail_Manager: '零售管理员',
    Store_Manager: '店铺管理员',
    Store_Staff: '店铺员工',
    Non_Retail_System: '非零售系统',
    Vacation: '休假',
    InfoIsDeletePerson: '是否删除选中的人员?',
    CurrentDefaultPosition: '当前默认职位：',
    SetDefaultPosition: '设置默认职位',
    DefaultPosition: '默认职位',
    DefaultPositionChangeTo: '您将默认职位切换为',
    MAIL_NOTIFICATION: '邮件通知',
    UnorganizedConvertedStores: '非组织转换的店铺',
    OrganizationSubordinateOrganizations: '组织存在下级组织',
    EnterpriseSynchronizationOnly: '企微同步的组织才可以转换',
    AccountAlreadyExists: '账户已存在',
    WorkMailboxAlreadyExists: '工作邮箱已存在',
    PersonnelDoesNotExist: '人员不存在',
    SEND_SMS_NOTIFICATION: '发送短信通知',
    SEND_MAIL_NOTIFICATION: '发送邮件通知',
    RELEVANT_PERSONNEL: '相关人员',
    BIND_ROLE: '绑定角色',
    DELETE_LABEL: '删除标签',
    SELECTED_LABEL_HAVE_ROLE_OR_PERSON_ISDELETE: '选中的标签存在绑定角色/人员，是否确认删除?',
    SELECTED_LABEL_HAVE_STORE_ISDELETE: '该标签下有绑定店铺，请确认是否删除?',
    PERSON_LABEL: '人员标签',
    LABEL_NAME_ALREADY_EXISTS: '标签名称已存在',
    LABEL_DOES_NOT_EXIST: '标签不存在',
    LABEL_MANAGEMENT: '标签管理',
    SHOP_COVER: '店铺封面',
    UPLOAD_COVER: '上传封面',
    DELETE_COVER: '删除封面',
    PICTURE_CAPTURE: '图片截取',
    PLEASE_SELECT_CORRECT_PICTURE_FORMAT: '请选择正确的图片格式!',
    NOTE_CURRENTLY_SELECTED: '注：当前选中',
    SHOP_PAGE_ONLY_SHOW_AND_MAINTAIN_COMMON_TAGS: '家店铺，本页面仅显示和维护这些店铺的共有标签',
    QW_BIND_STATUS: '企微绑定状态',
    STORE_FLOOR_PLANS: '店铺平面图',
    UPLOAD_FLOOR_PLAN: '上传平面图',
    FLOOR_PLAN_NAME: '平面图名称',
    LOOK_FLOOR_PLAN: '查看平面图',
    CLICK_UPLOAD: '点击上传',
    ONLY_UPLOAD_JPG_OR_PNG_FILE: '只能上传jpg/png文件',
    PLEASE_UPLOAD_A_2000_2000_PIXEL_IMAGE: '图片上传为控制在2000*2000像素以内!',
    CHOICE_DATE: '选择日期',
    PLEASE_BEFORE_SELECT_ORGANIZATION: '请先选择组织',
    NOTE_OLD_ORGANIZATION_NAME: '注：原组织名称',
    RETURN_FOR_ORG: '还原为组织',
    THE_ORG_NO_ALLOW_TURN_SHOP: '该组织不允许转为店铺',
    ExcelTemplate_common_000001: '组织ID',
    ExcelTemplate_common_000002: '组织名称',
    ExcelTemplate_common_000003: '上级组织ID',
    ExcelTemplate_common_000004: '上级组织名称',
    ExcelTemplate_common_000005: '组织类型',
    ExcelTemplate_common_000006: '是否企微同步',
    ExcelTemplate_common_000007: '备注',
    CHECKED: '已选：',
    CHECKED_PERSON: '已选人员：',
    CHECKED_STORE: '已选店铺：',
    DEVICE_MANAGEMENT: '设备管理',
    MECHANICAL_ARM: '机械臂',
    Equipment_Number: '设备编号',
    Device_Type: '设备类型',
    Device_SN: '设备SN',
    Intranet_IP: '内网IP',
    ARM_BRAND: '品牌',
    MODEL: '型号',
    Installation_POSITION: '安装位置',
    CUSTOMER: '所属客户',
    INTERNET_IP: '外网IP',
    STATE: '状态',
    LAST_USE_TIME: '最近使用时间',
    OFFLINE: '离线',
    ONLINE: '在线',
    DEVICE_INFO: '设备信息',
    z_info_common_000104: '状态（下架：0，上架：1）',
    TEST_QUESTION: '试卷问题',
    DISPLAY_BROCHURE_RELATIONSHIP: '陈列手册关系',
    ITEM_INVENTORY: '道具库存',
    KPI_SALES_TARGET: 'KPI销售目标',
    FILE_FORMAT_ERROR_PLEASE_UPLOAD_EXCAL: '文件格式不正确,请上传excel格式文件',
    FILE_ALREADY_UPLOAD_YOU_CAN_VIEW_IMPORT_ASSISTANT: '文件已上传, 您可以在导入助手中查看数据导入结果',
    BUSINESS_HOURS_OPENING: '营业时间（开店）',
    BUSINESS_HOURS_CLOSE: '营业时间（关店）',
    LABLE_ABOUT_PERSON: '标签"xxx"的相关人员',
    LABLE_ABOUT_STORE: '标签"xxx"的相关店铺',
    TYPE_NAME_ALREADY_EXISTS: '类型名称已存在',
    TYPE_IS_BEING_NOT_ALLOWED_DELETE: '类型正被引用，不允许被删除',
    NO_DATA_DELETE: '没有可被删除的数据',
    SET_DEFAULT: '设为默认',
    worker_common_000015: '直营',
    worker_common_000016: '经销',
    infoapi_common_000019: '经销',
    SUPERIOR_NAME: '上级姓名',
    SUPERIOR_ACCOUNT: '上级账号',
    ORG_TYPE_CANNOT_SET_ENTERPRISE_DEPARTMENT_STORE: '组织类型不能设置为“企业”，“部门”或“店铺”',
    DEPARTMENT: '部门',
    worker_common_000001: '组织类型不能为空;',
    worker_common_000002: '新增组织时，组织类型不能为企业或店铺;',
    worker_common_000003: '上级组织ID不能为空;',
    worker_common_000004: '上级组织ID格式错误;',
    worker_common_000006: '组织类型不存在;',
    worker_common_000007: '上级组织不存在;',
    worker_common_000010: '组织ID格式错误;',
    worker_common_000011: '组织不存在;',
    worker_common_000074: '组织不存在;',
    worker_common_000012: '无法将父组织串接到它的子组织下;',
    worker_common_000013: '修改组织类型时，原组织类型为店铺的无法更新;',
    worker_common_000014: '修改组织类型时，原组织类型为企业的无法更新;',
    worker_common_000017: '正常',
    infoapi_common_000021: '正常',
    worker_common_000018: '闭店',
    infoapi_common_000020: '闭店',
    worker_common_000019: '新增组织时，是否企微同步字段必须设置为N;',
    worker_common_000020: '店铺编号不能为空;',
    worker_common_000021: '店铺名称不能为空;',
    worker_common_000022: '店铺语言不能为空;',
    worker_common_000023: '品牌不能为空；',
    worker_common_000024: '货币不能为空；',
    worker_common_000025: '状态不能为空；',
    worker_common_000026: '店铺ID格式不正确；',
    worker_common_000027: '店铺ID不存在；',
    worker_common_000028: '店铺类型不存在；',
    worker_common_000035: '店铺类型不存在；',
    worker_common_000029: '上级组织ID不存在；',
    worker_common_000030: '品牌名称不存在；',
    worker_common_000031: '货币格式不正确；',
    worker_common_000032: '状态格式不正确；',
    worker_common_000033: '闭店时间格式不正确；',
    worker_common_000034: '闭店时间不正确；',
    worker_common_000036: '地区不存在；',
    worker_common_000037: '经营类型不存在；',
    worker_common_000038: '营业时间（开店）时间格式不正确;',
    worker_common_000039: '营业时间（闭店）时间格式不正确;',
    worker_common_000040: '营业开始时间必须早于营业结束时间;',
    worker_common_000041: '平面图文件标题不能为空;',
    worker_common_000042: '平面图文件ID格式错误;',
    worker_common_000052: '平面图文件ID格式错误;',
    worker_common_000043: '店铺编号已经存在；',
    worker_common_000044: '店铺名称已经存在；',
    worker_common_000045: 'Excel中店铺名称重复；',
    worker_common_000046: 'Excel中店铺编号重复；',
    worker_common_000047: '店铺编号长度不能超过12个字符;',
    worker_common_000048: '店铺名称长度不能超过200个字符;',
    worker_common_000049: '店铺英文名称长度不能超过200个字符;',
    worker_common_000050: '店铺状态错误;',
    worker_common_000051: '平面图标题长度不能超过2000个字符;',
    worker_common_000053: '店铺地址长度不能超过300个字符;',
    worker_common_000054: '店铺邮箱格式不合法;',
    worker_common_000055: '店铺电话长度不能超过200个字符;',
    worker_common_000056: '店铺联系人长度不能超过200个字符;',
    worker_common_000057: '店铺联系人电话长度不能超过200个字符;',
    worker_common_000058: '姓名不能为空;',
    worker_common_000059: '账号不能为空;',
    worker_common_000060: '姓名长度不能超过50个字符;',
    worker_common_000061: '账号长度不能超过50个字符;',
    worker_common_000062: '角色不能为空;',
    worker_common_000063: '组织不能为空;',
    worker_common_000064: '用户状态不能为空;',
    worker_common_000065: '用户状态不存在;',
    worker_common_000066: '用户类型不存在;',
    worker_common_000067: '国家地区不存在;',
    worker_common_000068: '性别不存在;',
    worker_common_000069: '入职日期格式错误;',
    worker_common_000070: '生日格式错误;',
    worker_common_000071: '邮箱格式错误;',
    worker_common_000072: 'Excel中账号重复;',
    worker_common_000073: '角色不存在;',
    worker_common_000075: 'UserID格式错误;',
    worker_common_000076: '账号重复;',
    worker_common_000077: '有效期格式错误;',
    worker_common_000078: '有效期必须大于当前日期;',
    worker_common_000079: '未找到用户数据;',
    worker_common_000080: '邮箱重复;',
    worker_common_000081: '角色不允许多人任职;',
    worker_common_000082: '上级用户不存在;',
    ExcelTemplate_common_000014: '入职日期',
    ExcelTemplate_common_000015: '上级姓名',
    ExcelTemplate_common_000016: '上级账号',
    ExcelTemplate_common_000022: '国家/地区',
    infoapi_common_000018: '直营',
    infoapi_common_000025: '零售管理',
    infoapi_common_000026: '店铺管理',
    worker_common_000083: {
      other: 'Excel中店铺ID重复'
    },
    EXPORT_PEOPLE: '导出人员',
    EXPORT_STAFF: '导出人员任职',
    worker_common_000085: '组织中存在相同的店铺名称',
    worker_common_000086: '平面图文件ID数据错误',
    ExcelTemplate_common_000023: '企微ID',
    worker_common_000088: '组织ID不能为空值；',
    worker_common_000089: '角色名称不能为空值；',
    worker_common_000091: '组织ID格式不正确',
    worker_common_000094: 'Excel中存在重复的职位',
    ABOUT_PERSON: '的相关人员',
    ABOUT_STORE: '的相关店铺',
    DOWNLOAD_POSITION_TEMPLATE: '下载任职模板',
    IMPORT_PERSONNEL_POSITION: '导入人员职位',
    ALLOW: '允许',
    NOT_ALLOW: '不允许',
    NOT_EDIT_TYPE: '类型不允许编辑',
    NOT_DELETE_TYPE: '类型不允许删除',
    CURRENT_USER_TYPE_NOT_EDIT: '当前用户类型不允许编辑',
    ROLE_DATA_NOT_DELETE: '存在不允许删除的角色数据，删除失败',
    LEAEVE_NOT_OVER: '允许查看上级组织人员层数不能超过7级',
    ROLE_POSITION_IS_USE_NOT_DELETE: '删除失败，角色中有职位已被使用',
    worker_common_000098: '角色ID不合法',
    worker_common_000101: '角色名称长度不能超过50个字符',
    worker_common_000102: 'Excel中同角色名称重复',
    worker_common_000103: '用户类型不能为空',
    worker_common_000104: '是否允许多人的数据不合法',
    worker_common_000105: '备注的长度超过了300个字符',
    worker_common_000084: '货币未启用；',
    currency_common_000001: '{用户名称}字符长度不能超过{50}字符;',
    currency_common_000002: '{用户名称}字符长度不能小于{5}字符;',
    currency_common_000003: '{用户ID}不合法;',
    currency_common_000004: '{用户名称}不能为空;',
    currency_common_000005: '{用户ID}格式错误;',
    currency_common_000006: '{用户名称}已存在;',
    currency_common_000007: '{用户名称}不能重复;',
    currency_common_000008: '{用户}不存在;',
    UPDATE_ROLE_AUTHORITY_TITLE: '角色“{xx}”的权限设定',
    ALL_AUTHORITY: '所有权限',
    worker_common_000106: '导入更新时，角色和组织不允许修改，修改人员任职请使用导入人员职位功能;',
    infoapi_common_000032: '方案一',
    infoapi_common_000033: '方案二',
    infoapi_common_000034: '方案三',
    infoapi_common_000035: '下发任务类',
    infoapi_common_000036: '提交申请类',
    OPEN_STORE_DESC: '开放店铺后店铺列表对所有人开放',
    OPEN_ADDRESS_BOOK_DESC: '开放通讯录后同事列表对所有人开放',
    ALLOW_EXPORT_OF_CONTACTS_DESC: '开放后通讯录中信息允许导出至手机通讯录中',
    CHANGE_PASSWORD_AT_FIRST_LOGIN_DESC: '选中后首次登录的用户必须修改密码',
    TURN_ON_THE_WATERMARK_ON_THE_SCREEN_OF_THE_MOBILE_PHONE_DESC: '勾选后通讯录背景中会有水印',
    DEFAULT_PASSWORD_CONFIGURATION: '默认密码配置',
    RANDOM_PASSWORD1: '随机密码',
    MODULE_COLOR: '模块颜色',
    ONLY_RPLUS_QYWX: '仅支持R+企微版',
    SYSTEM_DISTRIBUTION: '系统配色',
    CUSTOM_COLOR_MATCHING: '自定义配色',
    RESTORE_DEFAULT_COLOR: '恢复默认颜色',
    CLOPY_COLOR: '复制颜色',
    ADHESIVE_COLOR: '黏贴颜色',
    SUCCESS_COLOR: '复制成功',
    z_info_common_000109: '允许删除巡店报告时间',
    z_info_common_000110: '天内',
    z_info_common_000111: '允许删除巡店报告',
    z_info_common_000112: '允许删除巡店报告时间范围为1~999',
    INFO_TIPS_PERSON: '账号已存在',
    ACCOUNT_HAVE_DELETE_INFO: '该账号已删除，如需使用请进行恢复',
    BRAND_NO_DELETE_INFO: '该品牌已有店铺使用，不允许删除',
    SHOP_TEMPLETE_CONFIG: '巡店模板配置',
    SHOP_TEMPLETE_CONFIG_DESC: '勾选后可以让用户在提交巡店报告之前预览报告',
    BASIC_FIELD_CONFIG: '基础字段配置',
    CUSTOM_FIELD_CONFIG: '自定义字段配置',
    THE_ORG_NO_ALLOW_TURN_SHOP1: '该组织有下级组织，不允许转为店铺',
    NO_EDIT_TIPS: '企微同步的角色不允许修改',
    WEEK_SET: '周设置（每周第一天）',
    MECHANISM_CONTAINS_THE_WEEK_OF_JANUARY_1: '包含1月1日的周',
    MECHANISM_WEEK_CONTAINING_1_FIRST_THURSDAY: '包含第一个周四的周',
    UPLOAD_LIMIT_WORD: '仅支持Word格式，文件大小不能超过10M',
    ENLARGE: '放大',
    NARROW: '缩小',
    TURN_LEFT: '左转',
    TURN_RIGHT: '右转',
    AGREEMENT_HAVE: '协议已存在',
    WEEK_SET_1: '周设置',
    COST_RECORD: '成本记录',
    PROJECT_MAINTENANCE: '项目维保',
    PROBLEM_DESCRIPTION_REQUIRED: '问题描述必填',
    ACCEPTANCE_SCORING_REQUIRED: '验收打分必填',
    VISIBLE_ROLE: '可见角色',
    VISIBLE_REGIO: '可见组织',
    NO_LIMIT: '不限制',
    SELECT_ORG: '选择组织',
    ENABLE_CLASSIFICATION_PERMISSIONS: '启用分类权限',
    AUTO_SUCCESS: '自动完成',
    PROP_APPLY_MIN_IMG_CONFIG: '道具申请最少图片配置',
    ACCEPTANCE_MIN_IMG_CONFIG: '验收最少图片配置',
    ALLOW_REISSUE: '允许补发',
    REPAIR_MAIL_CONFIG: '报修邮件配置',
    USER_STATUS_QUIT: '离职',
    ORGANIZATION_PATH: '组织路径',
    USER_HAS_RESIGNED: '用户已离职',
    UPDATE_ORGANIZATION_PARENT_WARNING: '修改上级组织后, 该组织的上级组织将不再与企微同步',
    SMART_SCREEN: '互动屏',
    SMART_SCREEN_ID: '互动屏ID',
    SMART_SCREEN_LOCATION: '所在店铺',
    SMART_SCREEN_STATUS: '设备状态',
    SMART_SCREEN_REGISTERATION_DATE: '注册时间',
    r_info_common_000001: '道具批量验收',
    d_info_common_000001: '道具批量验收',
    r_info_common_000002: '提交维修项目',
    r_info_common_000003: '访问道具分析报表',
    d_info_common_000003: '访问道具分析报表',
    r_info_common_000004: '访问维修分析报表',
    d_info_common_000004: '访问维修分析报表',
    r_info_common_000005: '审核次品报修申请',
    d_info_common_000005: '审核次品报修申请',
    r_info_common_000006: '提交次品报修申请',
    d_info_common_000006: '提交次品报修申请',
    r_info_common_000007: '查询次品报修申请',
    d_info_common_000007: '查询次品报修申请',
    r_info_common_000008: '使用次品报修',
    d_info_common_000008: '使用次品报修',
    r_info_common_000009: '管理巡店计划',
    r_info_common_000010: '查看销售上报',
    d_info_common_000010: '查看销售上报',
    r_info_common_000011: '使用销售上报',
    d_info_common_000011: '使用销售上报',
    r_info_common_000012: '开启用户轨迹',
    d_info_common_000012: '开启用户轨迹',
    r_info_common_000013: '查看他人跟进报修',
    d_info_common_000013: '查看他人跟进报修',
    r_info_common_000014: '产品报修总部客服_南通',
    d_info_common_000014: '产品报修总部客服_南通',
    r_info_common_000015: '产品报修总部客服_如东',
    d_info_common_000015: '产品报修总部客服_如东',
    r_info_common_000016: '管理维修工',
    d_info_common_000016: '管理维修工',
    r_info_common_000017: '提交产品报修申请',
    d_info_common_000017: '提交产品报修申请',
    r_info_common_000018: '管理产品报修',
    d_info_common_000018: '管理产品报修',
    r_info_common_000019: '查看用户轨迹',
    d_info_common_000019: '查看用户轨迹',
    r_info_common_000020: '查看他人职店项目',
    d_info_common_000020: '查看他人职店项目',
    r_info_common_000021: '职店项目创建',
    d_info_common_000021: '职店项目创建',
    r_info_common_000023: '查看数据上报',
    d_info_common_000023: '查看数据上报',
    r_info_common_000024: '访问报表中心',
    d_info_common_000024: '访问报表中心',
    r_info_common_000025: '管理销售目标',
    d_info_common_000025: '管理销售目标',
    r_info_common_000026: '查看他人陈列项目',
    r_info_common_000027: '修改店铺信息',
    d_info_common_000027: '修改店铺信息',
    r_info_common_000028: '陈列项目管理',
    r_info_common_000029: '审核任务计划',
    r_info_common_000030: '查看任务计划',
    d_info_common_000030: '查看任务计划',
    r_info_common_000031: '自由提交道具申请',
    r_info_common_000032: '管理道具订单',
    r_info_common_000033: '查看道具订单',
    d_info_common_000033: '查看道具订单',
    r_info_common_000034: '更新道具库存',
    d_info_common_000034: '更新道具库存',
    r_info_common_000035: '查看道具库存',
    d_info_common_000035: '查看道具库存',
    r_info_common_000036: '管理道具信息',
    r_info_common_000037: '关闭道具申请',
    d_info_common_000037: '关闭道具申请',
    r_info_common_000038: '道具派单',
    r_info_common_000039: '浏览所有道具',
    r_info_common_000040: '道具验收',
    d_info_common_000040: '道具验收',
    r_info_common_000041: '提交道具申请',
    d_info_common_000041: '提交道具申请',
    r_info_common_000042: '访问道具申请',
    d_info_common_000042: '访问道具申请',
    r_info_common_000043: '自由提交维修申请',
    r_info_common_000044: '管理维修订单',
    r_info_common_000045: '查看维修订单',
    d_info_common_000045: '查看维修订单',
    r_info_common_000046: '关闭维修申请',
    d_info_common_000046: '关闭维修申请',
    r_info_common_000047: '维修派单',
    r_info_common_000048: '维修验收',
    d_info_common_000048: '维修验收',
    r_info_common_000049: '提交维修申请',
    d_info_common_000049: '提交维修申请',
    r_info_common_000050: '访问店铺报修',
    r_info_common_000051: '邮箱同时收取巡店报告',
    r_info_common_000052: '使用绩效考核',
    r_info_common_000053: '删除用户',
    r_info_common_000054: '修改用户信息',
    r_info_common_000055: '外勤签到',
    m_info_common_000016: '外勤签到',
    d_info_common_000055: '外勤签到',
    r_info_common_000056: '管理陈列手册',
    r_info_common_000057: '查看视觉陈列',
    d_info_common_000057: '查看视觉陈列',
    r_info_common_000058: '提交视觉陈列',
    d_info_common_000058: '提交视觉陈列',
    r_info_common_000059: '回复陈列照片',
    d_info_common_000059: '回复陈列照片',
    r_info_common_000060: '更改陈列状态',
    r_info_common_000061: '访问KPI图表',
    d_info_common_000061: '访问KPI图表',
    r_info_common_000062: '使用交接本',
    r_info_common_000063: '视频直播',
    m_info_common_000017: '视频直播',
    r_info_common_000064: '录入客流数据',
    d_info_common_000064: '录入客流数据',
    r_info_common_000065: '管理任务计划',
    r_info_common_000066: '提交巡店报告',
    r_info_common_000067: '使用在线培训',
    d_info_common_000067: '使用在线培训',
    r_info_common_000068: '查看组织下全部文档',
    r_info_common_000069: '录入销售数据',
    d_info_common_000069: '录入销售数据',
    r_info_common_000070: '查看他人未审核巡店报告',
    r_info_common_000071: '管理公共文件',
    r_info_common_000072: '访问巡店分析仪表盘',
    d_info_common_000072: '访问巡店分析仪表盘',
    r_info_common_000073: '使用移动学习',
    d_info_common_000073: '使用移动学习',
    r_info_common_000074: '查看他人任务组',
    r_info_common_000075: '新增客户',
    d_info_common_000075: '新增客户',
    r_info_common_000076: '移动学习管理',
    d_info_common_000076: '移动学习管理',
    r_info_common_000077: '管理App首页轮播栏',
    d_info_common_000077: '管理App首页轮播栏',
    r_info_common_000078: '查看店铺隐藏字段',
    d_info_common_000078: '查看店铺隐藏字段',
    r_info_common_000079: '管理任务组计划',
    r_info_common_000080: '添加新用户',
    r_info_common_000081: '研华IoT套件',
    d_info_common_000081: '研华IoT套件',
    r_info_common_000082: '管理任务组',
    r_info_common_000083: '配置公司流程',
    r_info_common_000084: '管理巡店模板',
    r_info_common_000085: '管理自定义表单',
    d_info_common_000085: '管理自定义表单',
    r_info_common_000086: '查看他人客户档案',
    r_info_common_000087: '查看任务组',
    r_info_common_000088: '查看巡店计划',
    d_info_common_000088: '查看巡店计划',
    r_info_common_000089: '查看店铺日历',
    d_info_common_000089: '查看店铺日历',
    r_info_common_000090: '添加自定义交接本',
    d_info_common_000090: '添加自定义交接本',
    m_info_common_000001: '自定义表单',
    m_info_common_000004: '道具管理',
    m_info_common_000005: '任务计划',
    m_info_common_000010: '项目验收',
    m_info_common_000011: '视觉陈列高级模块',
    m_info_common_000012: '数据看板',
    m_info_common_000013: 'E-Leaning',
    m_info_common_000014: 'e办事',
    m_info_common_000019: '店铺巡检',
    m_info_common_000021: '点数本',
    m_info_common_000022: 'VOIP拨号',
    m_info_common_000024: '园区商城',
    m_info_common_000025: '问候回访',
    m_info_common_000027: '任务组',
    m_info_common_000028: '产品报修',
    m_info_common_000031: '电话会议',
    m_info_common_000032: '移动学习',
    m_info_common_000033: '零售咨询',
    m_info_common_000034: 'KPI图表',
    m_info_common_000037: 'e商城',
    m_info_common_000039: '研华LoT套件',
    m_info_common_000040: '基础模块',
    d_info_common_000002: '在网页端使用批量申请功能创建维修项目，一次为多个店铺提交维修申请',
    d_info_common_000009: '发布、修改和关闭巡店计划',
    d_info_common_000026: '查看组织范围内他人创建的陈列项目',
    d_info_common_000028: '创建陈列项目，发布照片收集要求，审核陈列照片',
    d_info_common_000029: '审核任务计划下的任务',
    d_info_common_000031: '不受每天只能提交1次申请的限制，以及发货后7天内必须验收',
    d_info_common_000032: '管理道具订单，确认供应商的道具发货情况，关闭道具订单',
    d_info_common_000036: '添加、修改、删除道具',
    d_info_common_000038: '复核道具申请，派单给供应商，包含验收后要求重新发货',
    d_info_common_000039: '在网页端浏览公司所有道具的详细信息',
    d_info_common_000043: '不受每天只能提交1次申请的限制，以及派工日期到期后7天内必须验收',
    d_info_common_000044: '管理维修订单，确认供应商的维修方案和维修完工报告，关闭维修订单',
    d_info_common_000047: '复核维修申请，派单给供应商，包含验收后要求重新派工',
    d_info_common_000050: '使用店铺报修',
    d_info_common_000051: '如果用户在巡店报告提交时的收件人清单中，工作邮箱同时会收到巡店报告',
    d_info_common_000052: '使用绩效考核的所有功能',
    d_info_common_000053: '删除同级或下级用户',
    d_info_common_000054: '修改同级或下级的用户信息',
    d_info_common_000056: '上传、删除陈列手册，配置手册访问权限',
    d_info_common_000060: '更改一个店铺自由提交的陈列的状态',
    d_info_common_000062: '在交接本中查看记录、回复以及发布新记录',
    d_info_common_000063: '远程查看摄像机的图像',
    d_info_common_000065: '发布、修改和关闭任务计划',
    d_info_common_000066: '使用巡店并提交巡店报告',
    d_info_common_000068: '可以在“我”→“我的报告”：浏览组织下的全部文档，包含巡店检查报告、巡店问题报告、绩效考核报告',
    d_info_common_000070: '查看组织范围内等待其他人员审核的未审核巡店报告',
    d_info_common_000071: '上传、修改、删除公共文件，配置文件访问权限',
    d_info_common_000074: '查看组织范围内他人创建的任务组',
    d_info_common_000079: '创建、修改和删除任务组计划',
    d_info_common_000080: '添加同级或下级新用户',
    d_info_common_000082: '可以创建并对查看到的任务组进行修改和关闭',
    d_info_common_000083: '配置公司流程，目前有维修流程设置、道具流程设置',
    d_info_common_000084: '在网页端添加和配置巡店模板',
    d_info_common_000086: '查看组织范围内他人创建的客户档案',
    d_info_common_000087: '是否能看到任务组模块',
    z_info_common_000113: '确定转换成新模板？',
    SELECTED_ORGANIZATION_TO_STORE: '是否将选中的组织转为店铺?',
    SELECTED_ORGANIZATION_TO_STORE_FAIL: '组织转店铺失败',
    SELECTED_ORGANIZATION_TO_STORE_SUCCESS: '组织转店铺已成功',
    ORGANIZATION_TO_STORE: '组织转店铺',
    SELECTED_ORGANIZATION_TO_STORE_INFO: '{2}成功{0}条，{1}条无法{2}',
    mntapi_common_000212: '申请单信息',
    mntapi_common_000213: '申请项信息',
    CURRENT_POSITION: '职位显示效果',
    ExcelTemplate_common_000024: '显示职位',
    COSTUMER_CODE: '客户编码',
    COSTUMER_NAME: '客户名称',
    UPDATED_BY: '更新人',
    COSTUMER_RELATION: '客户管理',
    COSTUMER_RELATION_INFO: '客户信息',
    Rebinding: '重新同步',
    Rebinding_MSG1: '该操作将立刻将上级组织与企微端同步, 是否确认?',
    SELECTED_OPERATION_FAIL: '{0}失败',
    SELECTED_OPERATION_SUCCESS: '{0}已成功',
    Rebinding_MSG2: '重新同步仅针对与企微部门绑定但没有完全同步的{0}',
    SHOW_QY_USERNAME: '显示企微姓名',
    QY_USERNAME: '企微姓名',
    SHOW_QY_DEPARTMENTNAME: '显示企微部门名称',
    QY_DEPARTMENTNAME: '企微部门名称',
    QY_CANNOT_GET: '无法获取',
    RETURN_ORG_MSG: '店铺资料将被删除, 是否确认删除?',
    AREA_SETTING: '地区设定',
    CLOSE_STORE_AND_RECOVER: '闭店/恢复',
    AREA_INFO: '地区信息',
    SELECT_AREA: '选择地区',
    AREA_NAME_EXISTS: '地区名称已存在',
    COSTUMER_NAME_EXISTS: '客户名称已存在',
    COSTUMER_CODE_EXISTS: '客户编码已存在',
    AREA_CODE_EXISTS: '地区编号已存在',
    FIELD_MANAGEMENT: '字段管理',
    STORE_FIELD_MANAGEMENT: '店铺字段管理',
    SAVE_FIELD: '保存字段',
    ADD_FIELD: '添加字段',
    ADD_CATEGORYS: '添加分类',
    SYSTEM_FIELD: '系统字段',
    LAST_MODI_TIME: '最近修改时间',
    FIELD_TYPE: '字段类型',
    REQUIRED2: '必填',
    PUBLIC: '公开',
    AS_FILTER_KEY: '用做筛选项',
    STACK_SHELVES: '上架',
    WITHDRAW_SHELVES: '下架',
    MNT_CATEGORY: '维修分类',
    IS_STACK: '是否上架',
    SHOW_HAS_BEEN_WITHDRAWED_CATEGORY: '显示已下架的分类',
    MNT_CATEGORY_INFO: '维修分类信息',
    IS_DELETE_CATEGORY: '是否删除选中的分类?',
    PLZ_USE_WITHDRAW: '已经被使用的分类无法删除，请使用下架功能',
    SELECT_CATEGORY: '选择分类',
    VERSION_EXCEPTION: '版本异常',
    UN_INPUT_OPTION_EXIST: '存在未填写的必填项',
    FIELD_NOT_ALLOWED_REPEAT: '字段不允许重复',
    DEFAULT_LANG_CATEGORY_NAME_REQUIRED: '公司默认语言对应的名称必填',
    UNDER_SAME_PARENT_CATEGORY_NAME_NOT_ALLOWED_REPEAT: '同一上级维修分类下分类名称不能重复',
    UNDER_SAME_PARENT_CATEGORY_NO_NOT_ALLOWED_REPEAT: '同一上级维修分类下序号不能重复',
    ID_CAN_NOT_EMPTY_WHEN_UPDATE: '更新时，数据Id不能为空',
    PARENT_IS_WITHDRAWED: '上级维修分类为下架状态',
    UNDER_SAME_PARENT_PROP_ENG_NAME_NOT_ALLOWED_REPEAT: '同一上级道具分类下分类英文名称不能重复',
    UNDER_SAME_PARENT_PROP_NAME_NOT_ALLOWED_REPEAT: '同一上级道具分类下分类名称不能重复',
    IS_WITHDRAW_CATEGORY: '是否下架选中的分类?',
    WITHDRAW_SUCCESSFUL: '下架成功',
    STACK_SUCCESSFUL: '上架成功',
    PROP_CATEGORY_INFO: '道具分类信息',
    DELETE_IMG: '删除图片',
    ExcelTemplate_common_000025: '默认角色',
    ExcelTemplate_common_000026: '默认组织ID',
    MNT_QUESTION_CATEGORY: '维修问题分类',
    MNT_QUESTION: '维修问题',
    ExcelTemplate_common_000027: '多个标签使用"|"隔开',
    ExcelTemplate_common_000028: '标记*为必填字段, 导入时不可以为空',
    ExcelTemplate_common_000029: 'UserID新增用户无需填写, 导入更新时必须保留导出时的数据, 作为导入时定位用户的关键字段',
    ExcelTemplate_common_000030: '默认组织ID, 默认组织路径, 默认角色字段在导入时会同时影响用户的默认职位, 具体逻辑详见第二页, 未填写时将不会影响用户现有职位',
    ExcelTemplate_common_000031: '其他字段为非必填字段, 如果导入时未填写, 会清空系统中对应的字段.',
    ExcelTemplate_common_000032: '默认组织路径',
    MNT_QUESTION_CATEGORY_NAME: '维修问题分类名称',
    MNT_QUESTION_CATEGORY_INFO: '维修问题分类信息',
    MNT_QUESTION_INFO: '维修问题信息',
    MNT_QUESTION_NAME: '维修问题名称',
    ExcelTemplate_common_000041: '维修问题名称',
    r_info_common_000091: '允许查看物料价格',
    ExcelTemplate_common_000033: '维修问题ID',
    d_info_common_000091: '允许查看物料价格',
    ExcelTemplate_common_000034: '填写须知',
    ExcelTemplate_common_000035: '1. 请勿修改表格结构, 包括删除须知栏, 或者在该Excel表中对字段列进行增加、删除或修改；',
    ExcelTemplate_common_000036: '2. 标记*为必填字段, 导入时不可以为空',
    ExcelTemplate_common_000037: '3. 维修问题ID在导入新增问题时无需填写, 导入更新时必须保留导出时的数据, 作为导入时的关键字段',
    ExcelTemplate_common_000038: '4. 维修问题名称包含多个语言版本, 其中简体中文为必填, 其他语言选填',
    ExcelTemplate_common_000039: '5. 其他字段为非必填字段, 如果导入时未填写, 会清空系统中对应的字段.',
    ExcelTemplate_common_000040: '6. 所属分类, 默认优先级根据简体中文名称进行匹配',
    ExcelTemplate_common_000042: '3. 维修问题分类ID在导入新增分类时无需填写, 导入更新时必须保留导出时的数据, 作为导入时的关键字段',
    ExcelTemplate_common_000043: '4. 维修问题分类名称包含多个语言版本, 其中简体中文为必填, 其他语言选填',
    ExcelTemplate_common_000044: '5. 非必填字段, 如果导入时未填写, 会清空系统中对应的字段.',
    EXPORT_MNT_QUESTION: '导出维修问题',
    EXPORT_MNT_QUESTION_CATEGORY: '导出维修问题分类',
    IS_DELETE_QUESTION: '是否删除选中的问题?',
    DATA_HAS_BEEN_USED: '数据已使用，无法删除',
    CAN_NOT_REPEAT: '不能重复',
    SAME_MNT_QUESTION_CATEGORY_QUESTION_NAME_CAN_NOT_REPEAT: '同一维修问题分类下问题名称不能重复',
    DOWNLOAD_MNT_QUESTION_TEMPLATE: '下载维修问题模板',
    MNT_QUESTION_TEMPLATE: '维修问题模板',
    DOWNLOAD_MNT_QUESTION_CATEGORY_TEMPLATE: '下载维修问题分类模板',
    MNT_QUESTION_CATEGORY_TEMPLATE: '分类多语言模板',
    worker_common_000114: '维修问题分类不能为空',
    worker_common_000115: '无效的优先级',
    worker_common_000116: '默认语言的内容不能为空',
    worker_common_000117: 'ID无效',
    worker_common_000118: '维修问题分类下的维修问题存在重复',
    worker_common_000119: '维修问题分类存在重复',
    POFIELD_SAVE_FIELDCLASS_MSG: '已存在名为{0}的分类，请重新调整',
    POFIELD_SAVE_FIELD_MSG: '当前分类下已存在名为{0}的字段，请重新调整',
    EXPORT_STORE: '导出店铺',
    DOWNLOAD_EXCEL_QYTEMPLATE: '企微預綁定模板下載',
    QY_PRE_BINDING: '企微預綁定',
    QYUSER: '企微人員',
    STORE_LONG_FORM: '店鋪長表單',
    QYWX_CONFIG: '僅對企微所在部門為店舖的用戶添加"成員"相關職位',
    STORE_INFO_AREASQUARE: '面積',
    STORE_INFO_OPENDATE: '開店時間',
    STORE_INFO_CLOSEDATE: '闭店时间',
    STORE_INFO_DECORATIONDATE: '最近裝修時間',
    BINDING_QY_DEPARTMENT: '綁定企微部門',
    BINDING_QY_DEPARTMENT_DOWNLOAD: '下載綁定企微部門模板'
  },
  ...zhtLocale
}
